var XLSXBuilder =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var XMLElement = __webpack_require__(7);
var XMLAttribute = __webpack_require__(21);

/**
 * JSON representation of XML nodes. Each node has a tag an can have multiple {@link XMLAttribute} entries assigned.
 * It can also have multiple child {@link XMLNode} elements assigned. The node can contain a value.
 *
 * @param {object|string} oConfig - Object representation of the XMLNode containing at least the tag of the element.
 * @param {string} oConfig.tag - String representation of the XML tag.
 * @param {object[]} [oConfig.attributes] - Aggregation for adding {@link XMLAttributes} to the current node.
 * @param {object[]} [oConfig.properties] - Aggregation for adding {@link XMLNode} objects as child objects to this node
 * @param {string} [oConfig.value] - String value inside the XML tag.
 * @class
 * @module xml/XMLNode
 */
function XMLNode(oConfig) {
	var i, j, config;

	XMLElement.call(this, oConfig);

	/* Shorthand functionality to simply assign the XMLNode tag name instead of a configuration object */
	config = typeof oConfig === 'string' ? {tag: oConfig} : oConfig;

	Object.defineProperty(this, 'root', {value: !!config.root, writable: false});
	this.tag = typeof config.tag == 'string' ? config.tag : '';
	this.attributes = [];
	this.childs = [];

	/* Initialize the XML node by filling the aggregations if present */
	if (config.attributes) {
		for (i = 0; i < config.attributes.length; i++) {
			this.addAttribute(config.attributes[i]);
		}
	}

	if (config.properties) {
		for (j = 0; j < config.properties.length; j++) {
			this.addChild(config.properties[j]);
		}
	}
}

XMLNode.prototype = Object.create(XMLElement.prototype);
XMLNode.prototype.constructor = XMLNode;

XMLNode.processingInformation = '<?xml version="1.0" encoding="UTF-8"?>';


/**
 * Adds the provided XMLAttribute object to the XMLNode.
 * If no XMLAttribute is provided it will create one instead.
 * The method returns the XMLAttribute for chaining.
 *
 * @function addAttribute
 * @param {Object} oConfig - XMLAttribute or configuration object that represents a XMLAttribute
 * @returns {Object} - An instance of XMLAttribute that was added to this node
 */
XMLNode.prototype.addAttribute = function(oConfig) {
	var attribute = oConfig instanceof XMLAttribute ? oConfig : new XMLAttribute(oConfig);

	this.attributes.push(attribute);

	if (oConfig.id) {
		Object.defineProperty(this, oConfig.id, {value: attribute, writable: false, configurable: true});
	}

	return attribute;
};


/**
 * Adds the provided XMLNode object as child to the current XMLNode.
 * If no XMLNode is provided it will create one instead.
 * The method returns the XMLNode for chaining.
 *
 * @function addChild
 * @param {Object} oConfig - XMLNode or configuration object that represents a XMLNode
 * @returns {object} - An instance of XMLNode that was added to this node
 */
XMLNode.prototype.addChild = function(oConfig) {

	/* Additional Attributes of the child node will be added in the Constructor */
	var node = oConfig instanceof XMLNode ? oConfig : new XMLNode(oConfig);

	this.childs.push(node);

	if (oConfig.id) {
		Object.defineProperty(this, oConfig.id, {value: node, writable: false, configurable: true});
	}

	return node;
};


/**
 * Removes the property from this object and also deletes the
 * referenced item within the child nodes or attributes
 * aggregation.
 *
 * The method returns the previously referenced object or null if
 * the property name is not present on this particular XMLNode or
 * if no item is referenced.
 *
 * Builtin properties of XMLNode cannot be removed with this
 * function. These are "root", "tag", "attributes", "childs",
 * "value".
 *
 * @param {string} sProperty - Name of the property that should be removed
 * @returns {XMLNode|XMLAttribute|null} - The referenced object that gets removed as well
 */
XMLNode.prototype.remove = function(sProperty) {
	var index, referencedElement, aAggregation;

	/* Only proceed if property is present */
	if (!(sProperty in this)) {
		return null;
	}

	referencedElement = this[sProperty];

	/* Check if referenced element is a XMLAttribute */
	if (referencedElement instanceof XMLAttribute) {
		aAggregation = this.attributes;
	} else if (referencedElement instanceof XMLNode && !(sProperty in new XMLNode(''))) {
		aAggregation = this.childs;
	} else {

		/* Early return if referenced element is neither an XMLAttribute nor XMLNode */
		return null;
	}

	index = aAggregation.indexOf(referencedElement);
	aAggregation.splice(index, 1); // It is ensured that index > -1 otherwise #addChild or #addAttribute fail
	delete this[sProperty];

	return referencedElement;
};

/**
 * Allows recursive serialization of the object and its descendants. If the XMLNode is marked as root node,
 * it will automatically add the XML processing information in front of the serialized representation.
 *
 * @function serialize
 * @returns {string} - String representation of the XMLNode.
 */
XMLNode.prototype.serialize = function() {
	var sSerialized, i, j;

	sSerialized = (this.root ? XMLNode.processingInformation : '') + '<' + this.tag;

	/* Insert attributes including namespace information */
	for (i = 0; i < this.attributes.length; i++) {
		sSerialized += this.attributes[i].serialize();
	}

	/* Insert child nodes and value */
	if (this.childs.length || this.value || typeof this.value === 'number') {
		sSerialized += '>';
		sSerialized = (' ' + sSerialized).substr(1);

		for (j = 0; j < this.childs.length; j++) {
			sSerialized += typeof this.childs[j] === 'string' ? this.childs[j] : this.childs[j].serialize();
		}
		sSerialized += this.xmlEncode(this.value);

		sSerialized += '</' + this.tag + '>';
	} else {

		/* Shorthand tag support */
		sSerialized += '/>';
		sSerialized = (' ' + sSerialized).substr(1);
	}

	return sSerialized;
};

module.exports = XMLNode;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var XMLNode		 = __webpack_require__(0);

/**
 * The XMLFile class is a subclass of XMLNode that enriches the
 * object by path and file name information.
 *
 * @param {Object} oConfig - The configuration object for this XMLFile
 * @param {string} oConfig.path - The relative path of this XMLFile
 * @param {string} oConfig.filename - The file name of this XMLFile
 * @class
 */
function XMLFile(oConfig) {
	XMLNode.call(this, oConfig);

	this._filename = oConfig.filename;
	this._path = oConfig.path;
}

XMLFile.prototype = Object.create(XMLNode.prototype);
XMLFile.prototype.constructor = XMLFile;

/**
 * Returns the name of this particular file including its file extension.
 *
 * @returns {string} Name of the file
 */
XMLFile.prototype.getFileName = function() {
	return this._filename;
};

/**
 * Assigns the given string as name of the file. The name must contain a file extension.
 *
 * @param {string} sFileName - Name of the file
 */
XMLFile.prototype.setFileName = function(sFileName) {

	if (!sFileName.match(/^\S+\.\S{3,4}$/)) {
		throw new Error('Invalid file name: ' + sFileName);
	}

	this._filename = sFileName;
};

/**
 * Returns the path of the file without any filename.
 *
 * @returns {string} - Path of the file
 */
XMLFile.prototype.getPath = function() {
	return this._path;
};

/**
 * Returns the absolute Path to the file.
 *
 * @returns {string} - Absolute path including the filename
 */
XMLFile.prototype.getAbsolutePath = function() {
	return this.getPath() + this.getFileName();
};

/**
 * Assigns the given path to this XMLFile. The path needs to end with
 * a slash to match the criteria.
 *
 * @param {string} sPath - Relative path of this XMLFile
 */
XMLFile.prototype.setPath = function(sPath) {

	/* IE compatible endsWith */
	if (!sPath || sPath.lastIndexOf('/') !== (sPath.length - 1)) {
		throw new Error('Invalid file path: ' + sPath);
	}

	this._path = sPath;
};

/**
 * Performs a serialization of this XMLFile based on the XMLNode#serialize
 * implementation. The optional parameter allows to finalize this XMLFile
 * so that all aggregations will be cleared and the cleanup hook
 * XMLFile#cleanup will be executed. The aggregations will be cleared
 * outside of the cleanup function. This will ensure proper cleanup
 * even is the subclass is not calling the super class function.
 *
 * @param {boolean} [bFinalize]
 * Forces the XMLFile to destroy its aggregations. It will call the
 * cleanup function of the instance. This can be used as a hook for
 * subclasses that inherit from XMLFile. This frees additional memory
 * but should used with caution because after serialization all
 * content will be lost.
 *
 * @returns {string} The serialized XMLFile
 *
 * @Overrides XMLNode#serialize
 */
XMLFile.prototype.serialize = function(bFinalize) {
	var sSerializedString;

	sSerializedString = Object.getPrototypeOf(XMLFile.prototype).serialize.call(this);

	if (bFinalize) {
		this.childs.length = 0;

		this.cleanup();
	}

	return sSerializedString;
};

/**
 * Abstract function that can be overridden as a cleanup hook.
 * @abstract
 */
XMLFile.prototype.cleanup = function() {

	/* Do nothing */
};

module.exports = XMLFile;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/**
 * The Type class defines a supported data type, like strings,
 * numeric values, decimals, dates, currencies and so on. It is NOT
 * part of the XML representation of the generated Excel document.
 *
 * This class is marked as abstract therefore only its sub-classes
 * should be used.
 *
 * @constructor
 * @abstract
 */
function Type(oConfig) {
	this.styleId = null;
	this.alignment = oConfig && oConfig.textAlign ? oConfig.textAlign : null;
}

/**
 * Creates the type specific configuration that is used to register
 * its corresponding style in the Styles class.
 *
 * All subclass implementations have to call the superclass method to
 * ensure that alignment information will not be lost.
 *
 * @param {Object} oData - Line item that will be used to evaluate the cell content
 * @returns {Object} - Configuration object that may contain alignment information
 * @protected
 */
Type.prototype._createConfiguration = function(oData) {
	return this.alignment ? { align : {	horizontal: this.alignment }} : {};
};

/**
 * Returns the assigned ID of the Type specific Style that is
 * registered in the Styles class.
 *
 * @param {Object} [oData] - Business object that contains the actual data
 * @returns {number} - ID of the registered Style
 */
Type.prototype.getStyleId = function(oData) {
	if (this.styleId === null) {
		this.styleId = this.styles.addStyle(this._createConfiguration(oData));
	}

	return this.styleId;
};

/**
 * Registers the Style configuration of this Type in the given Styles
 * class.
 *
 * @param {Styles} oStyles - Styles instance where the Type specific styling will be registered
 */
Type.prototype.registerAt = function(oStyles) {
	this.styles = oStyles;
};

/**
 * Returns the data value of the business object that is bound by
 * this type.
 *
 * @param {string} property - Name of the property that shall be accessed.
 * @param {Object} oData - Business object that contains the data.
 *
 * @returns {string|number|boolean|null} - The value of the given property after type specific processing.
 */
Type.prototype.getValue = function(property, oData) {
	return oData[property];
};

module.exports = Type;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var XMLNode		 	= __webpack_require__(0),
	BigNumber		= __webpack_require__(11),
	CalendarDate 	= __webpack_require__(13),
	Numeric 		= __webpack_require__(5),
	BooleanType 	= __webpack_require__(14),
	Currency 		= __webpack_require__(4),
	SharedStrings   = __webpack_require__(15);

/**
 * The Cell class represents a single cell within the spreadsheet
 * that has to be assigned to a particular row. A Cell stores
 * information supporting several types of data.
 *
 * @param {Type} oType - The data type of the cell
 * @class
 */
function Cell(oType) {
	XMLNode.call(this, Cell.metadata);

	Object.defineProperty(this, 'type', { value: Cell.DataType.SharedString, writable: true });

	this._oFallbackType = null;
	this._applyType(oType);
}

Cell.prototype = Object.create(XMLNode.prototype);
Cell.prototype.constructor = Cell;

Cell.DataType = {
	Boolean: 'b',
	Date: 'd',
	InlineString: 'inlineStr', // We do not support inline strings
	Number: 'n',
	SharedString: 's',
	FormularString: 'str'
};

Cell._cellTypeProperty = 'cellType';

Cell.metadata = {
	tag: 'c',
	attributes: [
		{
			id: 'reference',
			name: 'r',
			value: ''
		},
		{
			id: 'style',
			name: 's',
			value: '0' // Default style id
		}
	],
	properties: [
		{
			id: 'text',
			tag: 'v'
		}
	]
};

/**
 * Applies the given type to the current Cell and maps to the
 * corresponding Office Open XML type definition.
 *
 * @param {Type} oType - Value of type {@link Type}
 * @private
 */
Cell.prototype._applyType = function(oType) {

	this.bindingType = oType;

	switch (oType.constructor) {
		case BooleanType:
			this.type = Cell.DataType.Boolean;

			if (!oType.isCustomFormatted()) {
				this.addAttribute({
					id: Cell._cellTypeProperty,
					name: 't',
					value: Cell.DataType.Boolean
				});
			}
			break;

		case CalendarDate:
			this.type = Cell.DataType.Date;
			break;

		case Numeric:
		case Currency:
			this.type = Cell.DataType.Number;

			/*
			 * As long as _applyType is only called once during
			 * initialization, the fallbackType can be registered
			 * without any additional check.
			 */
			this._oFallbackType = new BigNumber(oType);
			this._oFallbackType.registerAt(oType.styles);

			break;

		default: // Text is the default case
			this.addAttribute({
				id: Cell._cellTypeProperty,
				name: 't',
				value: Cell.DataType.SharedString // Default cell type
			});
			this.type = Cell.DataType.SharedString;
	}
};

/**
 * Applies the specified Style to the cell.
 *
 * @param {number|string} nStyle - Instance of Excel.objects.Style
 */
Cell.prototype.setStyle = function(nStyle) {
	this.style.value = nStyle;
};

/**
 * Applies the specified cell location as reference. The reference
 * must match the regular expression of Open Document SpreadsheetML
 * sheet format. Starting with at least one uppercase letter for the
 * column followed by a number without leading zeros for the row.
 * [A-Z]+[1-9]+[0-9]*
 *
 * @param {string} sReference - Reference of the cells' location
 */
Cell.prototype.setReference = function(sReference) {
	if (typeof sReference != 'string'
		|| !sReference.match(/^[A-Z]+[1-9]+[0-9]*$/g)) {
		throw new Error('The given Cell reference "' + sReference + '" does not match the reference pattern.');
	}

	this.reference.value = sReference;
};

/**
 * Assigns the value to the current Cell. The method requires a
 * property reference and a business object that gets bound depending
 * on the property. It is also possible to provide an array of
 * properties in case of aggregated columns.
 *
 * @param {(string|Array)} sProperty - single property or Array of properties
 * @param {Object} oBusinessObject - BusinessObject that gets bound to this Cell
 */
Cell.prototype.setValue = function(sProperty, oBusinessObject) {
	var shared, value, bindingType;

	bindingType = this.bindingType;
	value = bindingType.getValue(sProperty, oBusinessObject);

	if (!this._isValuePresent(value)) {

		/*
		 * We need to clear the value due to the fact
		 * that we are re-using the Cell for each row
		 */
		this.text.value = '';

		return;
	}

	switch (this.type) {
		case Cell.DataType.Boolean:

			/* String representations other than "true" will result in the boolean value false */
			if (typeof value === 'string') {
				value = value.toLowerCase() === 'true';
			}
			this.text.value = value ? '1' : '0';

			break;
		case Cell.DataType.Date:
			this.text.value = value;

			break;
		case Cell.DataType.Number:
			if (bindingType.isIEEE754Compliant(value)) {
				this.text.value = value;

				if (this[Cell._cellTypeProperty]) {
					this.remove(Cell._cellTypeProperty);
				}

				break;
			}

			/* Handle fallback case and insert value as SharedString */
			bindingType = this._oFallbackType;
			value = bindingType.getValue(sProperty, oBusinessObject);

			if (!this[Cell._cellTypeProperty]) {
				this.addAttribute({
					id: Cell._cellTypeProperty,
					name: 't',
					value: Cell.DataType.SharedString // Default cell type
				});
			}


			// CAUTION: break is omitted intentionally

		default: // SharedString is the default case
			shared = SharedStrings.getInstance();
			this.text.value = shared.insert(value);
	}

	/*
	 * Forces a style update once the value changed. This allows cell
	 * specific styles for currency types. Due to the fact that the
	 * Style ID gets cached within the Type, there is no performance
	 * impact even on large data sets.
	 */
	this.setStyle(bindingType.getStyleId(oBusinessObject));
};

/**
 * Checks whether there is a value provided or not. Allowed values
 * are Stringsas well as numeric and boolean values. Empty Strings
 * will be evaluated as no value, but the numeric value 0 is a value.
 *
 * @param {(string|number|boolean|Array)} data - The value that gets checked
 * @returns {boolean} - true if a value is present, false if not
 * @private
 */
Cell.prototype._isValuePresent = function(data) {
	return ((typeof data === 'string' && !!data)
		|| typeof data === 'number'
		|| typeof data === 'boolean'
		|| data instanceof Date);
};

module.exports = Cell;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Numeric = __webpack_require__(5),
	CurrencySettings = __webpack_require__(12);

/**
 * The Currency class represents a currency data type. It handles the
 * formatting and accepts several options like second property for
 * the unit of measurement or if the unit of measurement should be
 * displayed.
 *
 * It styles currencies with its particular amount of decimals.
 *
 * @param {Object} oConfig - A configuration object that is used to specify the formatting
 * @param {string} oConfig.unitProperty - A custom format string that will be used as template
 * @param {boolean} [oConfig.displayUnit] - Indicating whether the unit of measurement will be shown (default: true)
 * @param {number} [oConfig.scale] - A fixed scale that will be applied to all cells within this column,
 * regardless of its particular unit of measurement
 * @constructor
 */
function Currency(oConfig) {
	Numeric.call(this, oConfig);

	this.displayUnit = oConfig && typeof oConfig.displayUnit === 'boolean' ? oConfig.displayUnit : true;
}

Currency.prototype = Object.create(Numeric.prototype);
Currency.prototype.constructor = Currency;

/**
 * Returns the currency specific scale.
 *
 * @param {string} sCurrency - ISO currency code like USD for $ and EUR for € etc.
 * @returns {number} A number between 2 and 3 depending on the scale of the given currency
 * @public
 * @static
 */
Currency.getCurrencyScale = function(sCurrency) {
	var iScale;

	iScale = CurrencySettings.DIGITS[sCurrency];

	/* If the currency uses the default scale */
	if (typeof iScale !== 'number') {
		iScale = CurrencySettings.DIGITS.DEFAULT;
	}

	return iScale;
};

/**
 * Creates the Style configuration needed for registering the Type
 * specific styling in the Styles class.
 *
 * @param {Object} oData - Business object that gets bound to the styling template
 * @returns {Object} - Styling configuration object
 * @protected
 */
Currency.prototype._createConfiguration = function(oData) {
	var i, j, scale, template, unit;

	// TODO implement inheritance with Numeric class

	template = '#,##0';

	/* Apply fixed scale, only if no unitProperty is provided */
	if (!this.unitProperty && typeof this.scale === 'number') {
		scale = this.scale;
	} else {
		scale = Currency.getCurrencyScale(oData[this.unitProperty]);
	}

	/* Apply separator or placeholder */
	template += (scale > 0) ? '.' : '_.';

	for (i = 0; i < scale; i++) {
		template += '0';
	}

	for (j = CurrencySettings.DEFAULT_SCALE - scale; j > 0; j--) {
		template += '_0';
	}

	/* Add unit of measurement if required */
	if (this.displayUnit) {
		unit = oData[this.unitProperty] ? '"' + oData[this.unitProperty] + '"' : '_E_U_R';

		// Applies unit of measurement or a placeholder if unit is empty
		template = template + ' ' + unit;
	}

	// Add formatting for negative values as well
	template = '* ' + template + ';* - ' + template;

	return { numberFormat: { format: template } };
};

module.exports = Currency;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Type = __webpack_require__(2);

/**
 * The Numeric class represents a numeric data type. Numeric data can
 * handle several options like thousands delimiter, decimal (scale)
 * and different types like 'percent' and 'exponential'.
 *
 * @param {Object} [oConfig] - Configuration object for this numeric representation
 * @param {boolean} [oConfig.delimiter] - Indicates if a thousands delimiter should be used
 * @param {number} [oConfig.scale] - Defines the amount of decimals
 * @param {string} [oConfig.unit] - Specifies a particular unit of measurement
 * @param {string} [oConfig.unitProperty] - Specifies a property that contains the unit of measurement
 * @constructor
 */
function Numeric(oConfig) {
	Type.call(this, oConfig);

	this.unit = oConfig ? oConfig.unit : null;
	this.unitProperty = oConfig ? oConfig.unitProperty : null;
	this.delimiter = oConfig ? oConfig.delimiter : false;
	this.scale = oConfig ? oConfig.scale : null;

	this.styleIds = {};
}

Numeric.prototype = Object.create(Type.prototype);
Numeric.prototype.constructor = Numeric;

Numeric.DEFAULT = {
	numberFormat: 0
};

Numeric.builtin = {
	1: '0',
	2: '0.00',
	3: '#,##0',
	4: '#,##0.00',
	9: '0%',
	10: '0.00%',
	11: '0.00E+00',
	12: '# ?/?',
	13: '# ??/??',
	37: '#,##0;(#,##0)',
	38: '#,##0;[Red](#,##0)',
	39: '#,##0.00;(#,##0.00)',
	40: '#,##0.00;[Red](#,##0.00)',
	48: '##0.0E+0'
};

Numeric.scientificRegEx = /^-?\d?(\.\d)?\d*[eE][+-]?\d{1,3}$/;

/**
 * Creates the format according to the provided configuration. If the
 * format matches any builtin format, it will return a reference to
 * its ID instead of the format.
 *
 * Both cases can serve the Style class that consumes this information.
 *
 * @param {Object} oData - Business object that contains additional data that is used for the formatting
 * @returns {Object} - Configuration object for NumberFormat initialization
 * @protected
 */
Numeric.prototype._createConfiguration = function(oData) {
	var config, i, key,	template, unit;

	config = Object.getPrototypeOf(Numeric.prototype)._createConfiguration.call(this);

	if (!this.delimiter && typeof this.scale !== 'number' && !this.unit && !this.unitProperty) {
		config.numberFormat = Numeric.DEFAULT.numberFormat;

		return config;
	}

	template = Numeric.builtin[1];
	unit = '';

	if (this.delimiter) {
		template = '#,##' + template;
	}

	/* Add decimal*/
	if (typeof this.scale === 'number' && this.scale > 0) {
		template += '.';

		for (i = 0; i < this.scale; i++) {
			template += '0';
		}
	}

	/* Obtain unit of measurement if available */
	if (typeof this.unitProperty === 'string' && oData) {
		unit = ' "' + oData[this.unitProperty] + '"';
	} else if (typeof this.unit === 'string') {
		unit = ' "' + this.unit + '"';
	}

	/* Apply Unit */
	template += unit;

	config.numberFormat = {
		format: template
	};

	/* Find possible builtin match */
	for (key in Numeric.builtin) {
		if (Numeric.builtin[key] === template) {
			config.numberFormat = parseInt(key, 10);
		}
	}

	return config;
};

/**
 * Returns the assigned ID of the Type specific Style that is
 * registered in the Styles class.
 *
 * @param {Object} oData - Business Object that contains the property for the UoM
 * @returns {number} - ID of the registered Style
 */
Numeric.prototype.getStyleId = function(oData) {
	var styleId, unit;

	/* Handle simple numeric without unitProperty */
	if (!this.unitProperty) {
		return Object.getPrototypeOf(Numeric.prototype).getStyleId.call(this);
	}

	if (!oData) {
		return 0;
	}

	unit = oData[this.unitProperty];
	styleId = this.styleIds[unit];

	if (typeof styleId === 'undefined') {
		this.styleIds[unit] = this.styles.addStyle(this._createConfiguration(oData));
	}

	return this.styleIds[unit];
};

/**
 * Returns the data value of the business object that is bound by
 * this type. The value is normalized so that different input
 * representations will result in the same format.
 *
 * @param {string} sProperty - Name of the property that shall be accessed
 * @param {Object} oData - Business object that contains the data
 *
 * @returns {string|number|boolean|null} - The value of the given property after type specific processing.
 */
Numeric.prototype.getValue = function(sProperty, oData) {
	var aSegments, iScale, iExponent, sValue = oData[sProperty];

	if (typeof sValue == 'string' && Numeric.scientificRegEx.test(sValue)) {

		aSegments = sValue.split(/\.|[eE]/g);
		iScale = aSegments.length === 3 ? aSegments[1].length : 0;
		iExponent = Number(aSegments[aSegments.length - 1]);

		/* According to OData V4 Edm.Double is an IEEE 754 binary64 floating-point number (15-17 decimal digits) */
		sValue = Number(sValue).toFixed(Math.max(iScale - iExponent, 0));

		/* Write back the transformed value to avoid subsequent transformations */
		oData[sProperty] = sValue;
	}

	return sValue;
};

/**
 * Checks if the given value can be displayed in the IEEE 754
 * specification format. The function ignores leading and trailing
 * zeros and compares the length of the actual value does not exceed
 * 15 digits plus an optional decimal separator.
 *
 * The number might exceed 15 digits if it contains leading or
 * trailing zeros.
 *
 * @param {string} sValue - Numeric value that needs to be checked
 * @returns {boolean} - Whether the number needs to be formatted as BigNumber or not
 */
Numeric.prototype.isIEEE754Compliant = function(sValue) {
	var bCompliant = false;

	if (typeof sValue == 'number') {
		sValue = '' + sValue;
	}

	if (typeof sValue == 'string') {

		bCompliant = sValue
			.replace(/^-*0*|0+$/g, '')
			.split('.')
			.reduce(function(acc, value) {

				/*
				 * Returns 1 if the value left of the separator is
				 * zero and was cut of by removing leading and trailing zeros
				 */
				return (acc + value.length) || 1;
			}, 0) <= 15;
	}

	return bCompliant;
};

module.exports = Numeric;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var XMLNode = __webpack_require__(0);

/**
 * The Alignment class defines the alignment of content within the
 * sheet cells. The Alignment is assigned to a particular Style that
 * is registered in the Styles class.
 *
 * @constructor
 */
function Alignment() {
	XMLNode.call(this, Alignment.metadata);
}

Alignment.prototype = Object.create(XMLNode.prototype);
Alignment.prototype.constructor = Alignment;

Alignment.metadata = {
	tag: 'alignment'
};

Alignment.horizontal = {
	LEFT: 'left',
	CENTER: 'center',
	RIGHT: 'right',
	contains: function(sAlign) {

		return _contains(sAlign, Alignment.horizontal);
	}
};

Alignment.vertical = {
	TOP: 'top',
	MIDDLE: 'middle',
	BOTTOM: 'bottom',
	contains: function(sAlign) {

		return _contains(sAlign, Alignment.vertical);
	}
};

/**
 * Checks whether the requested alignment is contained or not. An
 * alignment that is contained can be assigned within styles. Other
 * alignments that are not contained are not supported and thus not
 * assignable. It differentiates between horizontal and vertical
 * alignments, depending on the aggregation that was provided.
 *
 * @param {string} sAlign - The alignment that should be checked
 * @param {Array} oAggregation - The aggregation the alignment might be in
 * @returns {boolean} - Returns true if the alignment is supported
 * @private
 */
function _contains(sAlign, oAggregation) {
	var key, contained = false;

	for (key in oAggregation) {
		contained = contained ? contained : oAggregation[key] === sAlign && typeof oAggregation[key] !== 'function';
	}

	return contained;
}

Alignment.prototype.isDefault = function() {
	return this.attributes.length == 0;
};

/**
 * Assigns the given indent to this Alignment object.
 *
 * @param {number} nIndent - Numerical value used as indentation
 */
Alignment.prototype.setIndent = function(nIndent) {

	/* Remove indent */
	if (typeof nIndent != 'number' || nIndent <= 0) {
		this.remove('indent');

		return;
	}

	this._setAlignmentAttribute('indent', nIndent);

	/* A correct indent requires an explicit horizontal alignment */
	if (!this.horizontal) {
		this.setHorizontalAlignment(Alignment.horizontal.LEFT);
	}
};


/**
 * Configures the wrapText attribute of the alignment which is used
 * for multiline text support.
 *
 * @param {boolean} bWrap - Defines if wrapping is enabled or disabled
 */
Alignment.prototype.setWrapText = function(bWrap) {
	var wrappingAttribute = 'wrapText';


	if (bWrap) {
		this._setAlignmentAttribute(wrappingAttribute, '1');

		return;
	}

	if (this[wrappingAttribute]) {
		this.remove(wrappingAttribute);
	}
};

/**
 * Applies the given alignment as horizontal alignment.
 *
 * @param {string} sAlign - Horizontal alignment that gets applied
 */
Alignment.prototype.setHorizontalAlignment = function(sAlign) {

	/* Ignore invalid values */
	if (!Alignment.horizontal.contains(sAlign)) {
		return;
	}

	this._setAlignmentAttribute('horizontal', sAlign);
};

/**
 * Applies the given alignment as vertical alignment.
 *
 * @param {string} sAlign - Vertical alignment that gets applied
 */
Alignment.prototype.setVerticalAlignment = function(sAlign) {

	/* Ignore invalid values */
	if (!Alignment.vertical.contains(sAlign)) {
		return;
	}

	this._setAlignmentAttribute('vertical', sAlign);
};

/**
 * Assigns the given value as a named property on this Alignment object.
 *
 * @param {string} id - The named property id
 * @param {number|string} value - Textual or numerical value
 * @private
 */
Alignment.prototype._setAlignmentAttribute = function(id, value) {

	/* Create attribute if not present */
	if (!this[id]) {
		this.addAttribute({
			id: id,
			name: id
		});
	}

	this[id].value = value;
};

Alignment.prototype.equals = function(oAlignment) {
	return typeof oAlignment !== 'undefined' && oAlignment !== null
		&& this.vertical == oAlignment.vertical
		&& this.horizontal == oAlignment.horizontal
		&& this.indent == oAlignment.indent
		&& this.wrapText == oAlignment.wrapText;
};

module.exports = Alignment;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * The XMLElement is an abstract base class that can store a
 * particular value and escape XML specific characters.
 *
 * @param {Object} oConfig - Configuration object that contains the value of this XML Element
 * @constructor
 * @abstract
 */
function XMLElement(oConfig) {
	this.value = oConfig && (oConfig.value || typeof oConfig.value === 'number') ? oConfig.value : '';
}

/**
 * Escapes the given String value to fulfill the requirements of
 * XML encoded characters. If the String does not contain any
 * character that needs to be encoded, the original String will
 * be returned.
 *
 * This significantly increases the performance because the
 * initial regular expression match is much faster than the
 * String replace function. We assume that only a few Strings
 * need to be encoded.
 *
 * The following characters need to be encoded:
 * < (lower than)
 * > (greater than)
 * " (quotes)
 * & (ampersand)
 *
 * @param {string} sValue - The value that needs to be XML encoded
 * @returns {string} - XML encoded String
 */
XMLElement.prototype.xmlEncode = function(sValue) {
	return typeof sValue === 'string' && sValue.match(/[><"&]+/) !== null ? this._replace(sValue) : sValue;
};

/**
 * @see _xmlEncode
 * @param {string} sValue - The string that contains characters that needs to be replaced
 * @returns {string} - XML encoded String
 * @private
 */
XMLElement.prototype._replace = function(sValue) {

	/**
	 * Perform ampersand replacement first to avoid encoding the
	 * control ampersand of other encoded characters.
	 *
	 * i.E. >& should be encoded as &gt;&amp; instead of &amp;gt;&amp;
	 */
	return sValue
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
};

module.exports = XMLElement;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var	XMLFile = __webpack_require__(1),
	XMLNode = __webpack_require__(0);

/**
 * @param {ReferenceNode} oReferenceNode - ReferenceNode object that is the root of this Relationships XMLFile
 * @constructor
 */
function Relationships(oReferenceNode) {
	XMLFile.call(this, Relationships.metadata);

	if (oReferenceNode instanceof XMLFile) {
		this.setFileName(oReferenceNode.getFileName() + '.rels');
		this.setPath(oReferenceNode.getPath() + '_rels/');
	}
}

Relationships.prototype = Object.create(XMLFile.prototype);
Relationships.prototype.constructor = Relationships;

Relationships.metadata = {
	filename: '.rels',
	path: '_rels/',
	tag: 'Relationships',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/package/2006/relationships'
		}
	],
	properties: []
};

/**
 * Creates a new Relationship entry for the current collection.
 * The Relationship references are defined by the ISO/IEC 29500-1:2016 standard.
 *
 * @param {string} sTarget - Target file within the generated Excel
 * @param {string} sType - XMLNS reference of the targets file type
 * @returns {string} The newly created relationship id that can be referenced i.E. "rId4"
 */
Relationships.prototype.addRelationship = function(sTarget, sType) {
	var id = 'rId' + (this.childs.length + 1);

	this.childs.push(new XMLNode({
		tag: 'Relationship',
		attributes: [
			{
				name: 'Id',
				value: id
			},
			{
				name: 'Type',
				value: sType
			},
			{
				name: 'Target',
				value: sTarget
			}
		]
	}));

	return id;
};

module.exports = Relationships;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var XMLFile		 = __webpack_require__(1),
	Row			 = __webpack_require__(10);

/**
 * This class represents a Sheet within an Office Open XML Spreadsheet.
 * @param {Object} oColumnConfiguration - ColumnConfiguration object that provides information about the columns
 * @constructor
 */
function Sheet(oColumnConfiguration) {
	XMLFile.call(this, Sheet.metadata);

	Object.defineProperty(this, '_columns', {value: oColumnConfiguration, writable: false});

	this._hierarchyProperty = oColumnConfiguration._hierarchyProperty;
	this._hierarchyLevel = 0;
	this._rowCount = 0;
	this._createCols();
	this._createHeader();
}

Sheet.prototype = Object.create(XMLFile.prototype);
Sheet.prototype.constructor = Sheet;

Sheet.metadata = {
	tag: 'worksheet',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main'
		},
		{
			name: 'xmlns',
			suffix: 'r',
			value: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships'
		},
		{
			name: 'xmlns',
			suffix: 'mc',
			value: 'http://schemas.openxmlformats.org/markup-compatibility/2006'
		}
	],
	properties: [
		{
			tag: 'sheetPr',
			properties: [
				{
					tag: 'outlinePr',
					attributes: [
						{
							name: 'summaryBelow',
							value: '0'
						}
					]
				}
			]
		},
		{
			id: 'dimension',
			tag: 'dimension',
			attributes: [
				{
					id: 'reference',
					name: 'ref',
					value: 'A1' // Default dimension of an empty Sheet
				}
			]
		},
		{
			id: 'views',
			tag: 'sheetViews',
			properties: [
				{
					id: 'defaultView',
					tag: 'sheetView',
					attributes: [
						{
							name: 'workbookViewId',
							value: '0'
						}
					],
					properties: [

						/* Freezes the header row */
						{
							id: 'pane',
							tag: 'pane',
							attributes: [
								{
									name: 'ySplit',
									value: '1'
								},
								{
									name: 'topLeftCell',
									value: 'A2'
								},
								{
									name: 'activePane',
									value: 'bottomLeft'
								},
								{
									name: 'state',
									value: 'frozen'
								}
							]
						}
					]
				}
			]
		},
		{
			id: 'format',
			tag: 'sheetFormatPr',
			attributes: [
				{
					name: 'defaultRowHeight',
					value: '15'
				}
			]
		},
		{
			id: 'columns',
			tag: 'cols'
		},
		{
			id: 'data',
			tag: 'sheetData'
		},
		{
			id: 'filter',
			tag: 'autoFilter',
			attributes: [
				{
					id: 'reference',
					name: 'ref',
					value: 'A1' // Default dimension of an empty Sheet
				}
			]
		},
		{
			tag: 'pageMargins',
			attributes: [
				{
					name: 'left',
					value: '0.75'
				},
				{
					name: 'right',
					value: '0.75'
				},
				{
					name: 'top',
					value: '1'
				},
				{
					name: 'bottom',
					value: '1'
				},
				{
					name: 'header',
					value: '0.5'
				},
				{
					name: 'footer',
					value: '0.5'
				}
			]
		}
	]
};

Sheet.MAX_ROWS = 1048576;

/**
 * Creates the column specific information within the worksheet.
 * Column specific information is i.E. the width or the use of the
 * bestFit functionality.
 *
 * @private
 */
Sheet.prototype._createCols = function() {
	var col, i, minWidth, width,
		autoFitButtonOffset = 2.4;

	/**
	 * Inner function for calculating the column width. The function
	 * will ceil the width to the next step of 0.25 so that the
	 * result mod step is 0.
	 * @param {number} nWidth - The width that needs to be adjusted
	 * @returns {number}  A width rounded to the accuracy of 0.25
	 */
	function roundWidth(nWidth) {
		var factor, step;

		step = 0.25;
		factor = 1 / step;

		return Math.ceil(nWidth * factor) / factor;
	}

	for (i = 0; i < this._columns.size(); i++) {
		col = this._columns.columns[i];
		minWidth = this._calculateColumnWidth(col.label.length) + autoFitButtonOffset;
		width = roundWidth(Math.max(this._calculateColumnWidth(col.width), minWidth));

		this.columns.addChild({
			tag: 'col',
			attributes: [
				{
					name: 'min',
					value: (i + 1)
				},
				{
					name: 'max',
					value: (i + 1)
				},
				{
					name: 'bestFit',
					value: '1'
				},
				{
					name: 'width',
					value: Math.max(width, minWidth)
				},
				{
					name: 'customWidth',
					value: '1'
				}
			]
		});
	}
};

/**
 * This method calculates the optimal column width for the given
 * amount of characters. It removes the dependency on font size or
 * pixel width.
 *
 * @param {number} nCharacters - Amount of characters that should fit into the column
 * @return {number} Excel internal width value corresponding to the used font size
 * @private
 */
Sheet.prototype._calculateColumnWidth = function(nCharacters) {
	var defaultFontSize = 11, // Needs to be adjusted once we support different font sizes
		defaultPaddingAndBorder = 5,
		scaleFactor = 7.33;

	if (typeof nCharacters !== 'number') {
		return 0;
	}

	return (((nCharacters * 2 / 3) * defaultFontSize) + defaultPaddingAndBorder) / scaleFactor;
};

/**
 * Sets the maximal hierarchy depth of this Sheet. The value will
 * only be changed if the given depth is higher than the previous
 * depth.
 *
 * @param {number} nHierarchyDepth - Numerical hierarchy depth
 * @private
 */
Sheet.prototype._setHierarchyDepth = function(nHierarchyDepth) {

	/* The maximum supported hierarchy depth is 7 */
	if (typeof nHierarchyDepth !== 'number' || nHierarchyDepth < 1 || nHierarchyDepth > 7) {
		return;
	}

	if (!this.format.hierarchyDepth) {
		this.format.addAttribute({
			id: 'hierarchyDepth',
			name: 'outlineLevelRow',
			value: nHierarchyDepth || 0
		});
	}

	this.format.hierarchyDepth.value = Math.max(this.format.hierarchyDepth.value, nHierarchyDepth);
};

/**
 * Requests the header Row from the ColumnConfiguration and adds it to the
 * sheet.
 *
 * @private
 */
Sheet.prototype._createHeader = function() {
	var headerRow = this._columns.getHeader();

	if (headerRow === null) {
		this.remove('filter');
		this.views.defaultView.remove('pane');

		return;
	}

	this._appendRow(headerRow);
};

/**
 * Adds the specified Row to the sheetData element of this Sheet and
 * automatically propagates its row index to the row and its cells.
 *
 * @param {Object} oRow - The Row object that should be appended to the current Sheet
 * @private
 */
Sheet.prototype._appendRow = function(oRow) {
	var dimension, sSerializedRow;

	this._rowCount++;
	oRow.setReference('' + (this._rowCount));

	sSerializedRow = oRow.serialize();

	/* Bundle two rows into one string */
	if (this._rowCount % 2 === 0) {
		sSerializedRow = this.data.childs.pop() + sSerializedRow;
	}

	/*
	 * Serializing the rows would create concatenated strings that are represented by a binary
	 * tree that references all substrings as leaves. This increases the memory usage massively.
	 *
	 * To avoid this string representation we need to convert the concatenated string to a
	 * sequential string by using String#split and Array#join. This reduces memory consumption
	 * and due to less Garbage Collection runs, also the runtime, although there is additional
	 * effort to convert the strings.
	 *
	 * Additional information can be found here:
	 * https://bugs.chromium.org/p/v8/issues/detail?id=2869
	 */
	this.data.childs.push((' ' + sSerializedRow).substr(1));

	/* Update sheet dimension */
	dimension = 'A1:' + Row.getColumnReferenceByIndex(this._columns.size() - 1) + this._rowCount;

	this.dimension.reference.value = dimension;

	if (this.filter) {
		this.filter.reference.value = dimension;
	}


};

/**
 * Creates a new group inside the sheet with the given hierarchy
 * level. All subsequent data rows will be assigned to this group.
 *
 * @function createGroup
 * @param {string} sName - Name of the group that will be displayed in the group header
 * @param {number} nLevel - Hierarchy level that will be used for outlining
 */
Sheet.prototype.createGroup = function(sName, nLevel) {
	var groupHeaderRow;

	this._hierarchyLevel = nLevel;
	groupHeaderRow = this._columns.getGroupHeader(sName);

	this._appendRow(groupHeaderRow);
};

/**
 * Requests a row from the ColumnConfiguration containing the given data
 * and adds it to the sheetData element of this Sheet.
 *
 * The maximum row limit is 1,048,576 but the user rather runs out of
 * memory than reaching this limit.
 *
 * @function insert
 * @param {Object} oData - Data object to be inserted
 */
Sheet.prototype.insert = function(oData) {
	var nHierarchyLevel;

	if (this._rowCount >= Sheet.MAX_ROWS) {
		throw new Error('Row limit reached.');
	}

	nHierarchyLevel =
		this._columns.hierarchyLevelProperty ? oData[this._columns.hierarchyLevelProperty] : this._hierarchyLevel;

	/* Create row and apply binding */
	this._appendRow(this._columns.bind(oData, nHierarchyLevel));
	this._setHierarchyDepth(nHierarchyLevel);
};

/**
 * Cleanup hook that gets executed when the XMLFil#serialize function
 * is called with the finalize flag.
 *
 * @private
 */
Sheet.prototype.cleanup = function() {
	this.remove('data');
};

/**
 * Returns the current row count of the Worksheet.
 *
 * @returns {number} - The amount of rows that are contained in this Worksheet
 *
 * @public
 */
Sheet.prototype.getRowCount = function() {
	return this._rowCount;
};

module.exports = Sheet;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Created by Sebastian Bender on 16.03.2017.
 */
var XMLNode = __webpack_require__(0);
var Cell	= __webpack_require__(3);

/**
 * The Row is representing a single row according to the Office Open
 * XML standard. A Row provides information about its index (line
 * number) and can contain several Cell objects.
 *
 * @class
 */
function Row() {
	XMLNode.call(this, Row.metadata);
}

Row.prototype = Object.create(XMLNode.prototype);
Row.prototype.constructor = Row;

Row.metadata = {
	tag: 'row',
	attributes: [
		{
			id: 'reference',
			name: 'r',
			value: ''
		},
		{
			id: 'spans',
			name: 'spans',
			value: '1:1'
		}
	]
};

/**
 * Calculates the Office Open XML Spreadsheet column reference for a
 * numeric value. Referring to the standard, the column is described
 * as a alphabetical value consisting of at least one uppercase character.
 * This function maps these alphabetical representation to numerical
 * zero-based indices.
 *
 * i.E. the column index 27 (which is the 28th column) results in 'AB'
 *
 * @param {number} nIndex - Numerical index for the requested column
 * @returns {string} - The alphabetical column reference for the given index.
 */
Row.getColumnReferenceByIndex = function(nIndex) {
	return nIndex < 26 ?
		String.fromCharCode(65 + nIndex) :
		Row.getColumnReferenceByIndex(Math.floor(nIndex / 26) - 1) + String.fromCharCode(65 + (nIndex % 26));
};


/**
 * Update the 'spans' attribute on this particular {@link Row} for
 * optimization purposes. This property optimizes the loading and
 * rendering in Microsoft Excel.
 *
 * @private
 */
Row.prototype._updateSpans = function() {
	this.spans.value = '1:' + this.childs.length;
};

/**
 * Adds the specified {@link Cell} to the current {@link Row}. If the
 * current row already has a reference or style, it will propagate
 * this information to the newly added Cell.
 *
 * @param {object} oCell - Instance of Excel.objects.Cell
 */
Row.prototype.addCell = function(oCell) {
	var count;

	if (!oCell || !(oCell instanceof Cell)) {
		return;
	}

	count = this.childs.push(oCell);
	this._updateSpans();

	/* Applies the cell reference if row reference is already present */
	if (this.reference.value) {
		oCell.setReference(Row.getColumnReferenceByIndex(count - 1) + this.reference.value);
	}

	if (this.style) {
		oCell.setStyle(this.style.value);
	}
};


/**
 * Updates the reference of the current {@link Row}. The Row reference
 * represents the line number within the Sheet. It will
 * automatically update all assigned Cell references.
 *
 * @param {string} sReference - Row number within the sheet
 */
Row.prototype.setReference = function(sReference) {
	var i, reference;

	reference = typeof sReference == 'number' ? String(sReference) : sReference;
	if (!reference || !reference.match(/^[1-9]+[0-9]*$/g)) {
		return;
	}

	/* Only update if necessary */
	if (this.reference.value != reference) {
		this.reference.value = reference;
		for (i = 0; i < this.childs.length; i++) {
			this.childs[i].setReference(Row.getColumnReferenceByIndex(i) + reference);
		}
	}
};

/**
 * Applies the given {@link Style} to the current {@link Row}.
 *
 * @param {(number|string)} nStyle - A number or string representing the Style id
 */
Row.prototype.setStyle = function(nStyle) {
	var i, style;

	if (!this.style) {
		style = this.addAttribute({name: 's'});
		Object.defineProperty(this, 'style', {value: style});
	}

	this.style.value = nStyle;
	for (i = 0; i < this.childs.length; i++) {
		this.childs[i].setStyle(nStyle);
	}
};

module.exports = Row;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Type = __webpack_require__(2);
var Currency = __webpack_require__(4);
var Alignment = __webpack_require__(6);

/**
 * The BigNumber class represents string formatted number with
 * specific formatting. It provides font and sizing details that
 * can be used by the Styles class.
 *
 * @param {Object} [oConfig] - Configuration object for this BigNumber type
 * @constructor
 */
function BigNumber(oConfig) {
	Type.call(this, oConfig);

	this.displayUnit = oConfig && typeof oConfig.displayUnit === 'boolean' ? oConfig.displayUnit : true;
	this.unit = oConfig ? oConfig.unit : null;
	this.unitProperty = oConfig ? oConfig.unitProperty : null;
	this.delimiter = oConfig ? oConfig.delimiter : false;
	this.scale = oConfig ? oConfig.scale : null;

	/**
	 * Due to default text alignment LTR, we need to invert the
	 * alignment so that it reflects the default number alignment
	 */
	this.alignment = this.alignment === null ? Alignment.horizontal.RIGHT : Alignment.horizontal.LEFT;
}

BigNumber.prototype = Object.create(Type.prototype);
BigNumber.prototype.constructor = BigNumber;

/**
 * Returns the data value of the business object that is bound by
 * this type. If a template is configured, it will automatically fill
 * the template with the values from the business object and returns
 * the processed string.
 *
 * @param {string} property - Name of the property that shall be accessed.
 * @param {Object} oData - Business object that contains the data.
 *
 * @returns {string|number|boolean|null} - The value of the given property after type specific processing.
 * Returns null if no value is present or the value cannot be processed by this type.
 */
BigNumber.prototype.getValue = function(property, oData) {
	var iScale, sResult, sUnit, sValue;

	sValue = oData[property];

	/* Convert number to string for BigNumber conversion */
	if (typeof sValue == 'number') {
		sValue = sValue.toString();
	}

	/* The value must be passed as a string containing only numerical characters with an optional decimal separator */
	if (typeof sValue != 'string' || !sValue.match(/^(-){0,1}[0-9]+(\.[0-9]+)*$/g)) {
		return null;
	}

	sUnit = oData[this.unitProperty] || this.unit;

	/* Apply fixed scale, only if no unitProperty is provided */
	if (!this.unitProperty && typeof this.scale === 'number') {
		iScale = this.scale;
	} else if (this.unitProperty) {
		iScale = Currency.getCurrencyScale(sUnit);
	}

	sResult = this._parseValue(sValue, iScale, this.delimiter);

	if (this.displayUnit) {
		sResult += (sUnit ? ' ' + sUnit : '');
	}

	return sResult;
};

/**
 * Parses a string representation of a numeric value according to the given requirements.
 *
 * @param {string} sValue - String representation of a numeric value
 * @param {number|null} [iScale] - Defines the scale of the numeric value ( >= 0)
 * @param {boolean} [bDelimiter] - Defines if thousand delimiters should be visible in the output
 * @returns {string} - Parsed representation
 * @private
 */
BigNumber.prototype._parseValue = function(sValue, iScale, bDelimiter) {
	var aSplitted, aInteger, i, sDecimal, sInteger, sSign;

	aSplitted = sValue.split('.');
	sInteger = aSplitted[0];
	sDecimal = aSplitted.length > 1 ? aSplitted[1] : '';

	/* Add thousand delimiter to the integer value */
	if (bDelimiter) {

		/* Remove sign before inserting the delimiter */
		aInteger = sInteger.split('');
		sSign = aInteger[0] === '-' ? aInteger.shift() : '';

		sInteger = sSign + aInteger.reduceRight(function(accumulator, currentValue) {
			return currentValue + (accumulator.length % 4 == 3 ? ',' + accumulator : accumulator);
		}, '');
	}

	if (typeof iScale === 'number') {
		if (iScale < sDecimal.length) {
			sDecimal = sDecimal.substring(0, iScale);
		} else {
			for (i = sDecimal.length; i < iScale; i++) {
				sDecimal += '0';
			}
		}
	}

	return sInteger + (sDecimal ? '.' + sDecimal : '');
};

module.exports = BigNumber;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * The CurrencySettings static object represents settings for the currency data type.
 * It provides digits for a specific currency and the default scale.
 */
var CurrencySettings = {};

/**
 * Update the default currency setting with customization.
 *
 * @param {Object} oConfig - A configuration object that is used to specify the currency settings.
 * @param {string} oConfig.defaultScale - A custom settings object that will be used for defining the default scale.
 * @param {string} oConfig.customCurrencies - A custom settings object that will be used for defining currency digits.
 * @public
 * @static
 */
CurrencySettings.update = function(oConfig) {
	var sCurrency;

	if (oConfig) {
		// Update default scale
		if (typeof oConfig.defaultScale === 'number') {
			CurrencySettings.DEFAULT_SCALE = oConfig.defaultScale;
		}
		// Update custom currencies
		if (oConfig.customCurrencies) {
			for (sCurrency in oConfig.customCurrencies) {
				CurrencySettings.DIGITS[sCurrency] = oConfig.customCurrencies[sCurrency].digits;
			}
		}
	}
};

/**
 * Defines the display default scale that is used for alignment. This has no effect on the technical scale of currency
 * values. It is only used for alignment purposes so that different currencies with different scale are still aligned
 * correctly.
 *
 * @type {number}
 */
CurrencySettings.DEFAULT_SCALE = 3;

CurrencySettings.DIGITS = {
	'ADP': 0,
	'AFN': 0,
	'ALL': 0,
	'AMD': 0,
	'BHD': 3,
	'BIF': 0,
	'BYR': 0,
	'CAD': 2,
	'CHF': 2,
	'CLF': 4,
	'CLP': 0,
	'COP': 0,
	'CRC': 0,
	'CZK': 0,
	'DEFAULT': 2,
	'DJF': 0,
	'ESP': 0,
	'GNF': 0,
	'GYD': 0,
	'HUF': 0,
	'IDR': 0,
	'IQD': 0,
	'IRR': 0,
	'ISK': 0,
	'ITL': 0,
	'JOD': 3,
	'JPY': 0,
	'KMF': 0,
	'KPW': 0,
	'KRW': 0,
	'KWD': 3,
	'LAK': 0,
	'LBP': 0,
	'LUF': 0,
	'LYD': 3,
	'MGA': 0,
	'MGF': 0,
	'MMK': 0,
	'MNT': 0,
	'MRO': 0,
	'MUR': 0,
	'OMR': 3,
	'PKR': 0,
	'PYG': 0,
	'RSD': 0,
	'RWF': 0,
	'SLL': 0,
	'SOS': 0,
	'STD': 0,
	'SYP': 0,
	'TMM': 0,
	'TND': 3,
	'TRL': 0,
	'TWD': 0,
	'TZS': 0,
	'UGX': 0,
	'UYI': 0,
	'UZS': 0,
	'VND': 0,
	'VUV': 0,
	'XAF': 0,
	'XOF': 0,
	'XPF': 0,
	'YER': 0,
	'ZMK': 0,
	'ZWD': 0
};

module.exports = CurrencySettings;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Type = __webpack_require__(2);

/**
 * The CalendarDate class represents a date/datetime/time data type.
 * It handles the formatting and accepts several options like
 * calendar, a custom format string and a subtype.
 *
 * @param {Object} [oConfig] - A configuration object that is used to specify the formatting
 * @param {string} [oConfig.type] - The specific type for this CalendarDate (i.E. date, datetime, time)
 * @param {string} [oConfig.format] - A custom format string that will be used as template
 * @param {string} [oConfig.calendar] - Specifies the calendar that will be used (default: gregorian)
 * @param {string} [oConfig.inputFormat] - Specifies the format of the string formatted date value (uppercase YYYYMMDD)
 * @constructor
 */
function CalendarDate(oConfig) {
	Type.call(this, oConfig);

	this.type = oConfig ? oConfig.type : null;
	this.format = oConfig ? oConfig.format : null;
	this.calendar = oConfig ? oConfig.calendar : null;
	this.inputFormat = oConfig && typeof oConfig.inputFormat == 'string' ? oConfig.inputFormat.toUpperCase() : null;
}

CalendarDate.prototype = Object.create(Type.prototype);
CalendarDate.prototype.constructor = CalendarDate;

CalendarDate.DEFAULT = {
	numberFormat: 14
};

CalendarDate.builtin = {
	14: 'mm-dd-yy',
	15: 'd-mmm-yy',
	16: 'd-mmm',
	17: 'mmm-yy',
	18: 'h:mm AM/PM',
	19: 'h:mm:ss AM/PM',
	20: 'h:mm',
	21: 'h:mm:ss',
	22: 'm/d/yy h:mm',
	45: 'mm:ss',
	46: '[h]:mm:ss',
	47: 'mmss.0'
};

CalendarDate.oSymbols = {
	'Y': {
		apply: function(sValue, oDate) {
			oDate.setUTCFullYear(sValue);
		}
	},
	'M': {
		apply: function(sValue, oDate) {
			oDate.setUTCMonth(sValue - 1);
		}
	},
	'D': {
		apply: function(sValue, oDate) {
			oDate.setUTCDate(sValue);
		}
	}
};

/**
 * Creates the Style configuration object for this CalendarDate
 * according to its configuration.
 *
 * @returns {Object} - Style descriptor object
 * @protected
 */
CalendarDate.prototype._createConfiguration = function() {
	var config, key, template;

	config = Object.getPrototypeOf(CalendarDate.prototype)._createConfiguration.call(this);

	if (!this.type && !this.format && !this.calendar) {
		config.numberFormat = CalendarDate.DEFAULT.numberFormat;

		return config;
	}

	/* Evaluate type */
	switch (this.type) {
		case 'datetime':
			template = CalendarDate.builtin[22];
			break;
		case 'time':
			template = CalendarDate.builtin[21];
			break;
		default: // Assume 'date' as default
			template = CalendarDate.builtin[14];
	}

	if (typeof this.format === 'string') {
		template = this.format.match(/^[dhmsy\s-,.:/]+(AM\/PM)?$/) ? this.format : template;
	}

	/* Evaluate calendar */
	switch (this.calendar) {
		case 'islamic':
			template = 'b2d mmmm yyyy';
			break;
		case 'japanese':
			template = '[$-ja-JP]ge.m.d';
			break;
		default: // Gregorian calendar is the default case
	}

	config.numberFormat = {
		format: template
	};

	/* Find possible builtin match */
	for (key in CalendarDate.builtin) {
		if (CalendarDate.builtin[key] === template) {
			config.numberFormat = parseInt(key, 10);
		}
	}

	return config;
};

/**
 * Returns the value of the given property that is assigned in the line item.
 *
 * @param {string} sProperty -
 * @param {Object} oData - Line item that contains data
 * @returns {number|null} - XLSX specific date/time format in days since 30.12.1899
 */
CalendarDate.prototype.getValue = function(sProperty, oData) {
	var value = oData[sProperty];

	if (value === null || typeof value === 'undefined') {
		return null;
	}

	/* Date or String, Number wrapper */
	if (typeof value === 'object') {
		value = value.valueOf();
	}

	/* 1. Unix timestamp as number */
	if (typeof value === 'number') {
		return CalendarDate._JsDateToExcel(value);
	}

	/* 2. Pattern formatted date string */
	if (this.inputFormat && typeof this.inputFormat === 'string') {

		return CalendarDate._JsDateToExcel(CalendarDate._parseStringDate(value, this.inputFormat));
	}

	/* 3. OData duration string 'PT01H23M45S' */
	if (this.type === 'time' && CalendarDate.odataDurationRegex.test(value)) {

		return CalendarDate._JsDateToExcel(CalendarDate._parseODataDuration(value));
	}

	/* 4. OData date string '/Date(1234567890)/' */
	if (CalendarDate.odataDateRegex.test(value)) {

		return CalendarDate._JsDateToExcel(CalendarDate._parseOdataDate(value));
	}

	/* 5. Unix timestamp as string */
	if (isFinite(value)) {
		return CalendarDate._JsDateToExcel(parseInt(value, 10));
	}

	return null;
};

/** START Copied and adapted from datajs **/
/**
 * Extracts the milliseconds if the value is a date/time instance or formatted string.
 *
 * @param {any} vValue the value (may be <code>undefined</code> or <code>null</code>)
 * @returns {any} the number of milliseconds or the value itself
 */
CalendarDate._parseODataDuration = function(vValue) {
	var parts, days, hours, minutes, seconds, ms;
	// / <summary>Parses a string in xsd:duration format.</summary>
	// / <param name="duration" type="String">Duration value.</param>
	// / <remarks>
	// / This method will return the input, if the input string has a year or a month component.
	// / </remarks>
	// / <returns type="Object">Object representing the time</returns>

	parts = CalendarDate.odataDurationRegex.exec(vValue);

	// Unsupported duration value for Edm.Time OData spec (if year of month is present)
	if (parts[2] || parts[3]) {
		return vValue;
	}

	days = parseInt(parts[4] || 0, 10);
	hours = parseInt(parts[5] || 0, 10);
	minutes = parseInt(parts[6] || 0, 10);
	seconds = parseFloat(parts[7] || 0);

	ms = parts[8];
	if (ms) {
		// Parse ms duration value ignoring any precision/scale as that part is anyway ignored by JS Date conversion!
		ms = parseFloat('0.' + ms) * 1000;
	} else {
		ms = 0;
	}

	ms += (seconds * 1000) + (minutes * 60000) + (hours * 3600000) + (days * 86400000);

	if (parts[1] === '-') {
		ms = -ms;
	}

	return ms;
};

/**
 * Parses an OData date string and returns the corresponding timestamp
 *
 * @param {string} sValue - OData date string i.E. "/Date(1524141637807)/"
 * @returns {number} - Unix timestamp according to OData date including offset
 * @private
 */
CalendarDate._parseOdataDate = function(sValue) {
	var matchArray, date, offset;

	/* The RegExp matches up to 4 groups:
		 * 0: Full match
		 * 1: Timestamp (mandatory)
		 * 2: Timezone offset sign [ + | - ] (optional)
		 * 3: Timezone offset minutes [0-9]{2,3} (optional)
		 */
	matchArray = CalendarDate.odataDateRegex.exec(sValue);
	date = new Date(parseInt(matchArray[1], 10));

	if (matchArray[2] && matchArray[3]) {
		offset = parseInt(matchArray[2] + matchArray[3], 10);
		date.setUTCMinutes(date.getUTCMinutes() - offset);
	}

	return date.getTime();
};

/* The regular expression corresponds to something like this:
 * /Date(123+60)/
 *
 * This first number is date ticks, the + may be a - and is optional,
 * with the second number indicating a timezone offset in minutes.
 *
 * On the wire, the leading and trailing forward slashes are
 * escaped without being required to so the chance of collisions is reduced;
 * however, by the time we see the objects, the characters already
 * look like regular forward slashes.
*/
CalendarDate.odataDateRegex = /^\/Date\((-?\d+)(\+|-)?(\d+)?\)\/$/;

// The captured indices for this expression are:
// 0       - complete input
// 1       - direction
// 2,3,4   - years, months, days
// 5,6,7,8 - hours, minutes, seconds, milliseconds
CalendarDate.odataDurationRegex =
	/^([+-])?P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)(?:\.(\d+))?S)?)?/;

/** END Copied and adapted from datajs */

CalendarDate.dateStringRegex = /([Y]{4,}|[M]{2}|[D]{2})/g;

/**
 * Converts a JavaScript Date object to an Office Open XML date
 * representation. Office Open XML date epoch starts at 00.01.1900
 * which is 31.12.1899 and is represented as a number of days since
 * beginning of the epoch.
 *
 * The Javascript Date epoch starts at 01.01.1970 and is represented
 * as a number of milliseconds before or after the beginning of the
 * epoch.
 *
 * The amount of days between 01.01.1900 and 01.01.1970 is exactly
 * 25567. According to the wrong offset in Excel (00.01.1900 instead
 * of 01.01.1900) and the known leap year bug in Excel, we need to
 * add two additional days.
 *
 * https://support.microsoft.com/en-us/help/214326/excel-incorrectly-assumes-that-the-year-1900-is-a-leap-year
 *
 *
 * @param {number} nTimestamp - JavaScript Date object or corresponding timestamp
 * @returns {number} - Amount of days since 31.12.1899
 * @private
 */
CalendarDate._JsDateToExcel = function(nTimestamp) {
	var offset;

	/* Increase the offset if date is after February 28th 1900 */
	offset = nTimestamp >= -2203891200000 ? 2 : 1;

	/**
	 * Fallback if date is before UTC 31.12.1899 00:00:00 which
	 * corresponds to 0 in Excel
	 */
	return Math.max((nTimestamp / (86400 * 1000)) + (25567 + offset), 0);
};

/**
 * The method parses a given string value according to the provided
 * date pattern.
 *
 * Limitations:
 * Currently only the symbols d, m, y are supported which correspond
 * to day, month, year.
 *
 * @param {string} sValue - Date formatted string
 * @param {string} sPattern - ISO 8601 pattern that gets applied
 * @returns {number|null} - UNIX timestamp that represents the parsed date string
 * @private
 */
CalendarDate._parseStringDate = function(sValue, sPattern) {
	var matchArray, date, substring;

	date = new Date(0);

	do {
		matchArray = CalendarDate.dateStringRegex.exec(sPattern);

		if (matchArray !== null) {
			substring = sValue.slice(matchArray.index, matchArray.index + matchArray[0].length);

			CalendarDate.oSymbols[matchArray[0].charAt(0)].apply(parseInt(substring, 10), date);
		}
	} while (matchArray !== null);

	return date.getTime();
};

module.exports = CalendarDate;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Type = __webpack_require__(2);

/**
 * The BooleanType class represents a boolean data type. BooleanType
 * data can work in two different ways. The first way is the Office
 * Open XML Spreadsheet built-in type that always shows TRUE/FALSE in
 * the users locale. This value can easily be used within formulas.
 *
 * @param {Object} [oConfig] - Configuration object for this numeric representation
 * @param {string} [oConfig.trueValue] - Contains the value that gets displayed if the Boolean is true
 * @param {string} [oConfig.falseValue] - Contains the value that gets displayed if the Boolean is false
 * @constructor
 */
function BooleanType(oConfig) {
	Type.call(this, oConfig);

	this.trueValue = oConfig ? oConfig.trueValue : null;
	this.falseValue = oConfig ? oConfig.falseValue : null;
}

BooleanType.prototype = Object.create(Type.prototype);
BooleanType.prototype.constructor = BooleanType;

BooleanType.DEFAULT = {
	numberFormat: 0
};

/**
 * This method indicates if the properties trueValue and falseValue
 * are configured correctly and the BooleanType supports a custom
 * format.
 *
 * @returns {boolean} - Whether to use a custom formatted BooleanType or the built-in type.
 */
BooleanType.prototype.isCustomFormatted = function() {
	return !!this.trueValue
		&& typeof this.trueValue === 'string'
		&& !!this.falseValue
		&& typeof this.falseValue === 'string';
};

/**
 * Creates the format according to the provided configuration. If the
 * format matches any builtin format, it will return a reference to
 * its ID instead of the format.
 *
 * Both cases can serve the Style class that consumes this information.
 *
 * @returns {Object} - Configuration object for NumberFormat initialization
 * @protected
 */
BooleanType.prototype._createConfiguration = function() {
	var config;

	config = Object.getPrototypeOf(BooleanType.prototype)._createConfiguration.call(this);
	config.numberFormat =
		this.isCustomFormatted() ?
			{ format: '"' + this.trueValue + '";;"' + this.falseValue + '"' } : BooleanType.DEFAULT.numberFormat;

	return config;
};

module.exports = BooleanType;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var XMLFile		 = __webpack_require__(1),
	SharedString	= __webpack_require__(24);

/**
 * The SharedStrings class represents the list of shared String
 * objects that is used in the Office Open XMl Spreadsheet. The
 * SharedStrings object reduces redundancy within the data by
 * providing a reference to unique Strings instead of repeating
 * them.
 *
 * Due to the fact that the Strings are shared within the whole
 * workbook, each instance of the document export only has one
 * single instance of SharedString and therefore it uses the
 * Singleton pattern to ensure this.
 *
 * @class
 */
function SharedStrings() {
	if (SharedStrings.instance instanceof SharedStrings) {
		return SharedStrings.instance;
	}

	XMLFile.call(this, SharedStrings.metadata);

	Object.defineProperty(this, 'map', {value: new Map(), writable: false});
	Object.defineProperty(this, '_shared', {value: new SharedString(''), writable: false});

	SharedStrings.instance = this;
}

SharedStrings.prototype = Object.create(XMLFile.prototype);
SharedStrings.prototype.constructor = SharedStrings;

/**
 * Retrieves the Singleton instance of SharedStrings. If no instance is present, it will create one.
 *
 * @function
 * @returns {object} - Singleton instance
 */
SharedStrings.getInstance = function() {
	if (!SharedStrings.instance) {
		SharedStrings.instance = new SharedStrings();
	}

	return SharedStrings.instance;
};

SharedStrings.metadata = {
	filename: 'sharedStrings.xml',
	tag: 'sst',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main'
		}

		/*
		,{
			name: 'count', // Optional as long as uniqueCount is not set
			value: '0'
		},
		{
			name : 'uniqueCount', // Optional as long as count is not set
			value: '0'
		}
		*/
	]
};

/**
 * Adds the specified string value to the set of SharedStrings. The
 * method creates a SharedString proxy object that contains
 * information about the string itself as well as its index. The
 * index is zero-based and can be used for referencing within Cell
 * objects.
 *
 * @function insert
 * @param {string} sValue - The string that has to be inserted
 * @return {object} - The SharedString instance that represents the provided string value
 */
SharedStrings.prototype.insert = function(sValue) {
	var index;

	if (this.map.has(sValue)) {
		return this.map.get(sValue);
	}

	this._shared.setValue(sValue);
	index = this.map.size;
	this.map.set(sValue, index);

	/* The SharedString needs to be added to the child nodes as well for serialization purposes */
	this.childs.push(this._shared.serialize());

	return index;
};

/**
 * Cleanup hook that gets executed when the XMLFil#serialize function
 * is called with the finalize flag.
 *
 * @private
 */
SharedStrings.prototype.cleanup = function() {
	this.map.clear();
};

module.exports = SharedStrings;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Type = __webpack_require__(2);
var Alignment = __webpack_require__(6);

/**
 * The Text class represents textual information without any
 * particular formatting. It provides font and sizing details that
 * can be used by the Styles class.
 *
 * @param {Object} [oConfig] - Configuration object for this Text type
 * @param {Object} [oConfig.font] - Font configuration object
 * @param {number} [oConfig.font.size] - Font size
 * @param {string} [oConfig.font.name] - Font name i.E. Arial, Verdana, etc.
 * @param {Object} [oConfig.fill] - Cell fill configuration object
 * @param {string} [oConfig.fill.color] - Cell fill background color
 * @param {string} [oConfig.fill.type] - Cell fill type
 * @param {string} [oConfig.template] - Text template for this Type
 * @param {string} [oConfig.hierarchyLevel] - Property name that is used for hierarchy level indentation
 * @param {boolean} [oConfig.wrap] - Indicates the wrapping behavior of the text cell
 * @constructor
 */
function Text(oConfig) {
	Type.call(this, oConfig);

	this.font = oConfig ? oConfig.font : null;
	this.fill = oConfig ? oConfig.fill : null;
	this.template = oConfig ? oConfig.template : null;
	this.hierarchyLevel = oConfig ? oConfig.hierarchyLevel : null;
	this.wrap = oConfig ? oConfig.wrap : false;

	this._styleIds = [];
}

Text.prototype = Object.create(Type.prototype);
Text.prototype.constructor = Text;

Text.DEFAULT = {
	font: {
		size: 11,
		name: 'Arial'
	}
};

/**
 * Ensures that all line breaks use CR + LF.
 *
 * @param {string} sValue - Text that may contain line breaks
 * @return {string} - Initial text with replaced line breaks
 */
Text.convertLineBreaks = function(sValue) {
	var compliantLineBreak = String.fromCharCode(13, 10);

	return sValue.replace(/\r/g, '').replace(/\n/g, compliantLineBreak);
};

/**
 * This method creates the XLSX specific style configuration depending on the cell content
 *
 * @param {Object} oData - Line item that will be used to evaluate the cell content
 * @returns {Object} - Style configuration used by the Styles class
 * @protected
 */
Text.prototype._createConfiguration = function(oData) {
	var config;

	config = Object.getPrototypeOf(Text.prototype)._createConfiguration.call(this);
	config.fill = this.fill;
	config.font = this.font;

	/* Overwrites existing alignment for a proper indent */
	if (this.hierarchyLevel) {
		config.align = {
			horizontal: Alignment.horizontal.LEFT,
			indent: 2 * oData[this.hierarchyLevel]
		};
	}

	/* Wrapping can be applied on hierarchies with indentation */
	if (this.wrap) {
		config.align = config.align || {};

		config.align.wrap = this.wrap;
	}

	return config;
};

/**
 * Returns the assigned ID of the Type specific Style that is
 * registered in the Styles class.
 *
 * @param {Object} oData - Business Object that contains the property for hierarchy levels
 * @returns {number} - ID of the registered Style
 */
Text.prototype.getStyleId = function(oData) {
	var styleId, level;

	/* Handle simple styling without hierarchy information */
	if (!this.hierarchyLevel) {
		return Object.getPrototypeOf(Text.prototype).getStyleId.call(this);
	}

	if (!oData) {
		return 0;
	}

	level = oData[this.hierarchyLevel];
	styleId = this._styleIds[level];

	if (typeof styleId === 'undefined') {
		this._styleIds[level] = this.styles.addStyle(this._createConfiguration(oData));
	}

	return this._styleIds[level];
};

/**
 * Returns the data value of the business object that is bound by
 * this type. If a template is configured, it will automatically fill
 * the template with the values from the business object and returns
 * the processed string.
 *
 * @param {string|Array} properties - Name of the property or array of properties that shall be accessed.
 * @param {Object} oData - Business object that contains the data.
 *
 * @returns {string|number|boolean} - The value of the given property after type specific processing.
 */
Text.prototype.getValue = function(properties, oData) {
	var match, regex, result, skip, value;

	if (!this.template) {
		value = typeof properties === 'string' ? oData[properties] : oData[properties[0]];

		value = this.wrap ? Text.convertLineBreaks(value) : value;

		return value;
	}

	// Obtain if the further processing should be skipped due to missing values for the template
	skip = properties.every(function(property) {
		return oData[property] === null
			|| typeof oData[property] === 'undefined'
			|| (typeof oData[property] === 'string' && oData[property] === '');
	});

	if (skip) {
		return '';
	}

	result = this.template;
	regex = /{([0-9]+)}/g;

	match = regex.exec(this.template);
	while (match !== null) {

		value = oData[properties[match[1]]];

		// Overwrite empty or undefined values by an empty string
		if (value === null || typeof value === 'undefined') {
			value = '';
		}

		// Replaces the matched placeholder by the indexed property value
		result = result.replace(match[0], value);

		match = regex.exec(this.template);
	}

	return result;
};

module.exports = Text;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var App					= __webpack_require__(20),
	ContentTypes		= __webpack_require__(22),
	Core				= __webpack_require__(23),
	Relationships		= __webpack_require__(8),
	Sheet				= __webpack_require__(9),
	Workbook			= __webpack_require__(25),
	CurrencySettings	= __webpack_require__(12);

/**
 * The XLSXBuilder class represents an Office Open XML Spreadsheet
 * (Microsoft Excel) that can be used to insert structured and
 * formatted data and pack a zipped *.xlsx document.
 *
 * XLSXBuilder requires JSZip 2.x or 3.x to be present.
 *
 * @param {(Object[]|string[])} aBinding - Binding configuration that is used for {@link Column} definition
 * @param {Object} [oContext] - Context object containing metadata for this particular XLSX
 * @param {string} [oContext.application] - Application that created this XLSX
 * @param {string} [oContext.version] - Application version that was used to create this XLSX
 * @param {string} [oContext.title] - Title of the XLSX document
 * @param {string} [oContext.modifiedBy] - User context for the exported document
 * @param {string} [oContext.sheetName] - The name of the data sheet that will be shown in Excel
 * @param {string} [oContext.metaSheetName] - The name of the metadata sheet that will be shown in Excel
 * @param {Object[]} [oContext.metainfo] - Optional Metadata that will be displayed in the additional Metadata Sheet
 * @param {string} [hierarchyLevel] - Name of the property that contains the hierarchy level of each lime item
 * @param {Object} [oCustomConfig] - Custom configuration object that can be used for {@link CurrencySettings} digits
 * and other customizations
 * @constructor
 */
function XLSXBuilder(aBinding, oContext, hierarchyLevel, oCustomConfig) {
	var aMetadataConfig, i, oMetainfoGroup, sSheetName, sMetadataSheetName;

	if (!(aBinding instanceof Array) || !aBinding.length) {
		throw new Error('No binding provided');
	}

	/* Set default values */
	sSheetName = 'SAP Document Export';
	sMetadataSheetName = 'Metadata';

	this.app = new this.objects.App(oContext);
	this.core = new this.objects.Core(oContext);
	this.workbook = new this.objects.Workbook();

	/* Configure currency settings if needed */
	if (oCustomConfig && oCustomConfig.currencySettings) {
		CurrencySettings.update(oCustomConfig.currencySettings);
	}

	/* Overwrite default Sheet names if maintained */
	if (oContext) {
		sSheetName = oContext.sheetName ? oContext.sheetName : sSheetName;
		sMetadataSheetName = oContext.metaSheetName ? oContext.metaSheetName : sMetadataSheetName;
	}

	this.sheet = this.workbook.addSheet(sSheetName, { columns: aBinding, hierarchyLevel: hierarchyLevel });
	this.workbook.selectSheet(this.sheet);

	if (typeof oContext === 'object' && oContext.metainfo instanceof Array) {

		/* Define column configuration for metadata sheet */
		aMetadataConfig = [
			{
				property: 'key',
				label: 'Key',
				width: 20
			},
			{
				property: 'value',
				label: 'Value',
				width: 20
			}
		];

		/* Add optional Metadata Sheet*/
		this.metadata = this.workbook.addSheet(sMetadataSheetName, { columns: aMetadataConfig, hideHeader: true });

		/*
		 * Add a copy of metadata to the Metadata Sheet. The method
		 * #_insertIntoSheet uses Array#shift and would otherwise
		 * manipulate the original metadata array.
		 */
		for (i = 0; i < oContext.metainfo.length; i++) {
			oMetainfoGroup = oContext.metainfo[i];

			this.metadata.createGroup(oMetainfoGroup.name, 1);
			this._insertIntoSheet(oMetainfoGroup.items.slice(), this.metadata);
		}
	}
}

XLSXBuilder.prototype = {

	objects: {
		App: App,
		ContentTypes: ContentTypes,
		Core: Core,
		Relationships: Relationships,
		Sheet: Sheet,
		Workbook: Workbook
	},

	/**
	 * Triggers the packaging process for the Office Open XML
	 * SpreadSheet. You need to call the method insert() first,
	 * otherwise the generated Document will contain no data.
	 *
	 * The method returns a promise to allow the library to work
	 * asynchronously.
	 *
	 * @function build
	 * @returns {object} - Packed zip file as Blob or Nodebuffer, depending on the runtime environment
	 */
	build: function() {
		var bFinalize, files, zip, i, j, fileConfig, FileType, xmlObject, relation, zipConfig, promise;

		files = [
			{
				name: '[Content_Types].xml',
				path: '',
				type: this.objects.ContentTypes
			},
			{
				name: '.rels',
				path: '_rels/',
				type: this.objects.Relationships,
				relationships: [
					{
						target: 'xl/workbook.xml',
						type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument'
					},
					{
						target: 'docProps/app.xml',
						type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties'
					},
					{
						target: 'docProps/core.xml',
						type: 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties'
					}
				]
			}
		];
		zip = new JSZip();
		bFinalize = true;

		for (i = 0; i < files.length; i++) {
			fileConfig = files[i];
			FileType = fileConfig.type;
			xmlObject = new FileType();

			if (xmlObject instanceof this.objects.Relationships) {
				for (j = 0; j < fileConfig.relationships.length; j++) {
					relation = fileConfig.relationships[j];
					xmlObject.addRelationship(relation.target, relation.type);
				}
			}

			zip.file(fileConfig.path + fileConfig.name, xmlObject.serialize());
		}

		// Add document metadata
		zip.file(this.app.getAbsolutePath(), this.app.serialize());
		zip.file(this.core.getAbsolutePath(), this.core.serialize());

		// Add workbook and its related files
		zip.file(this.workbook.getAbsolutePath(), this.workbook.serialize());
		zip.file(this.workbook.getRelationships().getAbsolutePath(), this.workbook.getRelationships().serialize());

		this.workbook.getRelatedFiles().forEach(function(file) {
			zip.file(file.getAbsolutePath(), file.serialize(bFinalize));
		});

		zipConfig = {
			compression: 'DEFLATE',
			type: JSZip.support.nodebuffer ? 'nodebuffer' : 'arraybuffer'
		};

		if (zip.generateAsync) {
			promise = zip.generateAsync(zipConfig);
		} else { // Zip.generate from JSZip 2.x
			promise = new Promise(function(resolve, reject) {
				var zipped = zip.generate(zipConfig);

				resolve(zipped);
			});
		}

		return promise;
	},

	/**
	 * Appends the specified set of data to the Open Document Spreadsheet.
	 * All data will be bound according to the {@link ColumnConfiguration}.
	 *
	 * @function append
	 * @param {(Object[]|Object)} aData - Array of data that gets appended to the Spreadsheet
	 */
	append: function(aData) {
		this._insertIntoSheet(aData, this.sheet);
	},

	/**
	 * Inserts the given data into the specified Sheet. The method will throw an Error if no Sheet is provided.
	 *
	 * @param {Array} aData - Array of business objects that should be inserted
	 * @param {Sheet} oSheet - The Sheet where the data should be inserted into
	 * @private
	 */
	_insertIntoSheet: function(aData, oSheet) {
		var array;

		/* We need to check if param is null or undefined because [null].length results in 1 */
		if (typeof aData === 'undefined' || aData === null) {
			return;
		}

		array = aData instanceof Array ? aData : [aData];

		while (array.length) {
			oSheet.insert(array.shift());
		}
	}
};

module.exports = XLSXBuilder;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var XMLFile = __webpack_require__(1);

/**
 * This class represents the app.xml within the generated Excel. The
 * App contains information about the application that created the
 * Office Open XML Spreadsheet.
 *
 * @param {Object} [oContext] - Context object containing metadata for this particular Excel
 * @param {string} [oContext.application] - Application that created this Excel
 * @param {string} [oContext.version] - Application version that was used to create this Excel
 * @constructor
 */
function App(oContext) {
	XMLFile.call(this, App.metadata);

	if (oContext) {

		if (oContext.application) {
			this.application.value = oContext.application;
		}

		if (oContext.version) {
			this.version.value = oContext.version;
		}
	}
}

App.prototype = Object.create(XMLFile.prototype);
App.prototype.constructor = App;

App.metadata = {
	path: 'docProps/',
	filename: 'app.xml',
	tag: 'Properties',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/officeDocument/2006/extended-properties'
		},
		{
			name: 'xmlns',
			suffix: 'vt',
			value: 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes'
		}
	],
	properties: [
		{
			id: 'application',
			tag: 'Application',
			value: 'SAP UI5' // Default value, can be overridden
		},
		{
			tag: 'DocSecurity',
			value: '0'
		},
		{
			tag: 'Company',
			value: 'SAP SE'
		},
		{
			tag: 'SharedDoc',
			value: 'false'
		},
		{
			id: 'version',
			tag: 'AppVersion',
			value: '1.68' // Default value, can be overridden
		}
	]
};

module.exports = App;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var XMLElement = __webpack_require__(7);

/**
 * The class XMLAttribute is a wrapper for representing XML-like attributes attributes.
 * It is mainly used for defining namespaces and namespace-related attributes.
 *
 * @param {object} oConfig - Object representation of the XMLNode containing at least the tag of the element.
 * @param {string} oConfig.name - String representation of the XML tag.
 * @param {string} [oConfig.prefix] - Prefix of the {@link XMLAttribute} that will be used for XML namespace purposes.
 * @param {string} [oConfig.suffix] - Suffix of the {@link XMLAttribute} that will be used for XML namespace purposes.
 * @param {string} [oConfig.value] - Textual value of the {@link XMLAttribute}.
 * @class
 * @module xml/XMLAttribute
 */
function XMLAttribute(oConfig) {
	XMLElement.call(this, oConfig);

	this.name = oConfig.name ? oConfig.name : '';
	this.prefix = oConfig.prefix ? oConfig.prefix : '';
	this.suffix = oConfig.suffix ? oConfig.suffix : '';
}

XMLAttribute.prototype = Object.create(XMLElement.prototype);
XMLAttribute.prototype.constructor = XMLAttribute;

/**
 * Performes a String serialization of the XMLAttribute. The representation is formatted as follows:
 * <prefix>:<name>:<suffix>="<value>"
 *
 * i.E. ' xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"'
 * for { name: 'xmlns', suffix: 'xsi', value: 'http://www.w3.org/2001/XMLSchema-instance' }
 *
 * Note that the serialized String always comes with a leading whitespace to allow easy concatenation.
 *
 * @function serialize
 * @returns {string} - String representation of the XMLAttribute
 */
XMLAttribute.prototype.serialize = function(){
	return ' ' + (this.prefix ? this.prefix + ':' : '') + this.name
		+ (this.suffix ? ':' + this.suffix : '') + '="' + this.xmlEncode(this.value) + '"';
};

module.exports = XMLAttribute;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var XMLFile = __webpack_require__(1);

/**
 * This class represents the [Content_Types].xml within the generated Excel.
 *
 * @constructor
 */
function ContentTypes() {
	XMLFile.call(this, ContentTypes.metadata);
}

ContentTypes.prototype = Object.create(XMLFile.prototype);
ContentTypes.prototype.constructor = ContentTypes;


ContentTypes.FILENAME = '';
ContentTypes.metadata = {
	filename: '[Content_Types].xml',
	tag: 'Types',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/package/2006/content-types'
		}
	],
	properties: [
		{
			tag: 'Default',
			attributes: [
				{
					name: 'Extension',
					value: 'xml'
				},
				{
					name: 'ContentType',
					value: 'application/xml'
				}
			]
		},
		{
			tag: 'Default',
			attributes: [
				{
					name: 'Extension',
					value: 'rels'
				},
				{
					name: 'ContentType',
					value: 'application/vnd.openxmlformats-package.relationships+xml'
				}
			]
		},
		{
			tag: 'Override',
			attributes: [
				{
					name: 'PartName',
					value: '/xl/workbook.xml'
				},
				{
					name: 'ContentType',
					value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml'
				}
			]
		},
		{
			tag: 'Override',
			attributes: [
				{
					name: 'PartName',
					value: '/xl/worksheets/sheet1.xml'
				},
				{
					name: 'ContentType',
					value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml'
				}
			]
		},
		{
			tag: 'Override',
			attributes: [
				{
					name: 'PartName',
					value: '/xl/styles.xml'
				},
				{
					name: 'ContentType',
					value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml'
				}
			]
		},
		{
			tag: 'Override',
			attributes: [
				{
					name: 'PartName',
					value: '/xl/sharedStrings.xml'
				},
				{
					name: 'ContentType',
					value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml'
				}
			]
		},
		{
			tag: 'Override',
			attributes: [
				{
					name: 'PartName',
					value: '/docProps/core.xml'
				},
				{
					name: 'ContentType',
					value: 'application/vnd.openxmlformats-package.core-properties+xml'
				}
			]
		},
		{
			tag: 'Override',
			attributes: [
				{
					name: 'PartName',
					value: '/docProps/app.xml'
				},
				{
					name: 'ContentType',
					value: 'application/vnd.openxmlformats-officedocument.extended-properties+xml'
				}
			]
		}
	]
};

module.exports = ContentTypes;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var XMLFile = __webpack_require__(1);

/**
 * This class represents the core.xml within the generated Excel. The
 * Core contains basic information about the content and the owner of
 * the file.
 *
 * @param {Object} [oContext] - Context object containing metadata for this particular Excel
 * @param {string} [oContext.title] - Title of the Excel document
 * @param {string} [oContext.modifiedBy] - User context for the exported document
 * @constructor
 */
function Core(oContext) {
	XMLFile.call(this, Core.metadata);

	if (oContext) {

		if (oContext.title) {
			this.title.value = oContext.title;
		}

		if (oContext.modifiedBy) {
			this.modifiedBy.value = oContext.modifiedBy;
		}
	}
}

Core.prototype = Object.create(XMLFile.prototype);
Core.prototype.constructor = Core;

Core.metadata = {
	path: 'docProps/',
	filename: 'core.xml',
	tag: 'cp:coreProperties',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			suffix: 'cp',
			value: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties'
		},
		{
			name: 'xmlns',
			suffix: 'dc',
			value: 'http://purl.org/dc/elements/1.1/'
		},
		{
			name: 'xmlns',
			suffix: 'dcterms',
			value: 'http://purl.org/dc/terms/'
		},
		{
			name: 'xmlns',
			suffix: 'dcmitype',
			value: 'http://purl.org/dc/dcmitype/'
		},
		{
			name: 'xmlns',
			suffix: 'xsi',
			value: 'http://www.w3.org/2001/XMLSchema-instance'
		}
	],
	properties: [
		{
			id: 'title',
			tag: 'dc:title',
			value: 'Table Export' // Default value, can be overridden
		},
		{
			tag: 'dc:creator',
			value: 'SAP UI5 Document Export'
		},
		{
			tag: 'dcterms:created',
			attributes: [
				{
					prefix: 'xsi',
					name: 'type',
					value: 'dcterms:W3CDTF'
				}
			],
			value: new Date().toISOString()
		},
		{
			tag: 'cp:keywords',
			value: 'SAP UI5 EXPORT'
		},
		{
			id: 'modifiedBy',
			tag: 'cp:lastModifiedBy',
			value: 'SAP UI5' // Default value, can be overridden
		}
	]
};

module.exports = Core;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var XMLNode = __webpack_require__(0);

/**
 * The SharedString class represents each shared String within the
 * SharedStrings file.
 *
 * @param {string} sValue - The String that gets represented by this SharedString object
 * @class
 */
function SharedString(sValue) {
	XMLNode.call(this, SharedString.metadata);

	this.setValue(sValue);
}

SharedString.prototype = Object.create(XMLNode.prototype);
SharedString.prototype.constructor = SharedString;

SharedString.formulaRegex = /^[=+-@](cmd|hyperlink).+$/gi;

SharedString.metadata = {
	tag: 'si',
	properties: [
		{
			id: 'text',
			tag: 't'
		}
	]
};

/**
 * Assigns the given value to the current SharedString instance.
 *
 * @function
 * @param {string} sValue - The string value that should be added
 */
SharedString.prototype.setValue = function(sValue) {

	/* Escape possible formula injection exploit */
	sValue = SharedString.formulaRegex.test(sValue) ? '\'' + sValue : sValue;

	if (sValue && typeof sValue == 'string') {
		this.text.value = sValue;
	} else {

		/**
		 * There are other implementations for creating a string
		 * representation out of a number that might be more
		 * convenient like new String(number).toString() or
		 * number.toString() but '' + number is the best performing.
		 */
		this.text.value = '' + sValue;
	}
};

/**
 * Serializes the XMLNode and transforms the concatenated string into a sequential string.
 * @return {string} - String representation of the SharedString
 *
 * @override
 */
SharedString.prototype.serialize = function() {
	var sSerialized;

	sSerialized = Object.getPrototypeOf(SharedString.prototype).serialize.call(this);

	return (' ' + sSerialized).substr(1);
};

module.exports = SharedString;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var ColumnConfiguration	= __webpack_require__(26),
	ReferenceNode		= __webpack_require__(29),
	SharedStrings		= __webpack_require__(15),
	Sheet				= __webpack_require__(9),
	Styles				= __webpack_require__(30);

/**
 * This class represents the workbook.xml file within the generated
 * Office Open XML Spreadsheet. The workbook is the central element
 * of the Office Open XML Spreadsheet that references all the content.
 *
 * @constructor
 */
function Workbook() {
	var key;

	ReferenceNode.call(this, Workbook.metadata);

	/* Create and register central Styles instance for this workbook */
	this._styles = new Styles();
	this._styles.setPath(this.getPath());
	this.addRelatedFile(this._styles);

	/* Create and register central SharedStrings instance for this workbook */
	this._sharedStrings = SharedStrings.getInstance();
	this._sharedStrings.setPath(this.getPath());
	this.addRelatedFile(this._sharedStrings);

	for (key in Workbook.RELATIONS) {
		this._relationships.addRelationship(Workbook.RELATIONS[key].target, Workbook.RELATIONS[key].type);
	}

	this._registeredSheets = [];
}

Workbook.prototype = Object.create(ReferenceNode.prototype);
Workbook.prototype.constructor = Workbook;

Workbook.RELATIONS = {
	sharedStrings: {
		target: 'sharedStrings.xml',
		type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings'
	},
	styles: {
		target: 'styles.xml',
		type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles'
	}
};

Workbook.metadata = {
	filename: 'workbook.xml',
	path: 'xl/',
	tag: 'workbook',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main'
		},
		{
			name: 'xmlns',
			suffix: 'r',
			value: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships'
		},
		{
			name: 'xmlns',
			suffix: 'mc',
			value: 'http://schemas.openxmlformats.org/markup-compatibility/2006'
		}
	],
	properties: [
		{
			tag: 'bookViews',
			properties: [
				{
					tag: 'workbookView',
					attributes: [
						{
							name: 'xWindow',
							value: '0'
						},
						{
							name: 'yWindow',
							value: '0'
						},
						{
							name: 'windowWidth',
							value: '22260'
						},
						{
							name: 'windowHeight',
							value: '12645'
						}
					]
				}
			]
		},
		{
			id: 'sheets',
			tag: 'sheets'
		},
		{
			id: 'definedNames',
			tag: 'definedNames'
		}
	]
};

/**
 * Adds a new {@link Sheet} to this {@link Workbook}
 *
 * @param {string} sName - Name of the {@link Sheet} that is used as label in Microsoft Excel
 * @param {Object} oConfig - The column configuration of this Sheet
 * @param {Array} oConfig.columns - Array containing the configuration for each column
 * @param {boolean} [oConfig.bHideHeader] - Hides the header row (optional - default: false)
 * @returns {Sheet} - The newly added {@link Sheet}
 */
Workbook.prototype.addSheet = function(sName, oConfig) {
	var oColumnConfiguration, nCount, sId, oSheet, sSheetFileName;

	nCount = this.sheets.childs.length + 1;
	sSheetFileName = 'sheet' + nCount + '.xml';
	sId = this._relationships.addRelationship('worksheets/' + sSheetFileName,
		'http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet');

	this.sheets.addChild({
		tag: 'sheet',
		attributes: [
			{
				id: 'name',
				name: 'name',
				value: sName
			},
			{
				name: 'sheetId',
				value: '' + nCount
			},
			{
				name: 'id',
				prefix: 'r',
				value: sId
			}
		]
	});

	oColumnConfiguration = new ColumnConfiguration(oConfig, this._styles);
	oSheet = new Sheet(oColumnConfiguration);
	oSheet.setFileName(sSheetFileName);
	oSheet.setPath(this.getPath() + 'worksheets/');

	this.addRelatedFile(oSheet);
	this._registeredSheets.push(oSheet);

	return oSheet;
};

/**
 * Set the given sheet as selected. Unselects all other sheets in the workbook.
 *
 * @param {Sheet} oSheet - The Sheet object that should be selected
 */
Workbook.prototype.selectSheet = function(oSheet) {

	if (!(oSheet instanceof Sheet) || this._registeredSheets.indexOf(oSheet) < 0) {
		throw new Error('Could not select sheet. Sheet not found.');
	}

	/* Remove selection on all sheets */
	this._registeredSheets.forEach(function(sheetElement, index, array) {
		sheetElement.views.defaultView.remove('selected');
	});

	/* Select the particular Sheet */
	oSheet.views.defaultView.addAttribute({
		id: 'selected',
		name: 'tabSelected',
		value: '1' // Refers to W3C XML Schema boolean (true)
	});
};

/**
 * Registers definedNames for sheets that use autoFilter
 * functionality before processing the super class serialization.
 *
 * @returns {string} - The serialized String representation of this workbook
 */
Workbook.prototype.serialize = function() {
	var that = this;

	/**
	 * Creates the value for the definedName. It automatically
	 * retrieves the dimension of the sheet that is used by the
	 * filter and escapes its representation.
	 *
	 * @param {string} sSheetName - The title of the sheet
	 * @param {Sheet} oSheet - The sheet object containing the filter dimension
	 * @returns {string} - Escaped definedName value
	 * @private
	 */
	function createDefinedName(sSheetName, oSheet) {
		var sDefinedName, sDimension;

		sDimension = oSheet.filter.reference.value;
		sDefinedName = sSheetName.indexOf(' ') < 0 ? sSheetName : '\'' + sSheetName + '\'';
		sDefinedName += '!';
		sDefinedName += sDimension.replace(/([A-Z]+)|(\d+)/g, function(match) {
			return '$' + match;
		});

		return sDefinedName;
	}

	/* Create definedNames before serializing the workbook */
	this._registeredSheets.forEach(function(oSheet, iIndex, aArray) {
		var sSheetName = that.sheets.childs[iIndex].name.value;

		if (oSheet.filter) {
			that.definedNames.addChild({
				tag: 'definedName',
				attributes: [
					{
						name: 'name',
						value: '_xlnm._FilterDatabase'
					},
					{
						name: 'localSheetId',
						value: iIndex
					},
					{
						name: 'hidden',
						value: '1'
					}
				],
				value: createDefinedName(sSheetName, oSheet)
			});
		}
	});

	return Object.getPrototypeOf(Workbook.prototype).serialize.call(this);
};

module.exports = Workbook;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Column	= __webpack_require__(27),
	Text	= __webpack_require__(16),
	Row		= __webpack_require__(10),
	Cell	= __webpack_require__(3);

/**
 * ColumnConfiguration represents the configuration of all columns within
 * one Sheet. The ColumnConfiguration handles the mapping of object
 * properties to certain columns,, labeling, type definition and also
 * display information like width and alignment.
 *
 * @param {Object} oConfig -  An configuration object that contains all necessary column definitions
 * @param {Object} oConfig.columns -  An array of Column definitions. {@see Column} for further details
 * @param {string} [oConfig.hierarchyLevel] -  Name of the property that holds the hierarchy level
 * @param {boolean} [oConfig.hideHeader] - Flag that allows to hide the header row
 * @param {Styles} oStyles - Style collection that is used to register Cell or row specific styles
 * @module binding/ColumnBinding
 * @constructor
 */
function ColumnConfiguration(oConfig, oStyles) {
	var aColumns, oColumn, i;

	this.columns = [];
	this._row = null;
	this.styles = oStyles;
	this.hideHeader = oConfig.hideHeader;

	Object.defineProperty(this, 'hierarchyLevelProperty', { value: oConfig.hierarchyLevel });

	aColumns = oConfig.columns;

	for (i = 0; i < aColumns.length; i++) {

		/* As of specification, the hierarchy level indentation will only be applied on the first row */
		if (i == 0) {
			if (typeof aColumns[i] === 'string') {
				aColumns[i] = { property: aColumns[i] };
			}

			aColumns[i].hierarchyLevel = this.hierarchyLevelProperty;
		}

		oColumn = aColumns[i] instanceof Column ? aColumns[i] : new Column(aColumns[i], this.styles);
		this.columns.push(oColumn);
	}
}

/**
 * Initializes the objects that are necessary for the binding. This
 * components are:
 * - a template Row
 * - a Cell for each Column
 * - a Style for each data type referenced by each Column
 *
 * @private
 */
ColumnConfiguration.prototype._initBinding = function() {
	var i;

	this._row = new Row();

	for (i = 0; i < this.columns.length; i++) {
		this._row.addCell(this.columns[i].getCell());
	}
};


/**
 * Creates an new Row and binds the provided data to the Row Cells according to the current ColumnConfiguration.
 *
 * @param {Object} oData - The data object that has to be bound to the row
 * @param {number} nHierarchyLevel - Hierarchy level that will be used for indent and outline
 * @returns {Row} - Returns the created Row that contains the provided data
 */
ColumnConfiguration.prototype.bind = function(oData, nHierarchyLevel) {
	var i, normalizedHierarchyLevel;

	if (this._row === null) {
		this._initBinding();
	}

	/* Normalise hierarchy depth to not exceed the maximum depth of 7 */
	normalizedHierarchyLevel = Math.min(nHierarchyLevel, 7);

	/*
	 * We need to add, update or delete the outline attribute because
	 * we reuse the row object
	 */
	if (normalizedHierarchyLevel && !this._row.outline) {
		this._row.addAttribute({
			id: 'outline',
			name: 'outlineLevel',
			value: normalizedHierarchyLevel
		});
	} else if (normalizedHierarchyLevel && this._row.outline) {
		this._row.outline.value = normalizedHierarchyLevel;
	} else if (!normalizedHierarchyLevel && this._row.outline) {
		this._row.remove('outline');
	}

	for (i = 0; i < this.columns.length; i++) {
		this.columns[i].bind(oData);
	}

	return this._row;
};


/**
 * Creates the header Row according to the current ColumnConfiguration and returns it.
 *
 * @returns {Row} - Header row according to the ColumnConfiguration
 */
ColumnConfiguration.prototype.getHeader = function() {
	var cell, row, type;

	if (this.hideHeader) {
		return null;
	}

	row = new Row();
	type = new Text({
		font: {
			name: 'Arial',
			size: 11,
			bold: true
		},
		fill: {
			color: 'F7F7F7'
		}
	});

	/* Register header style */
	type.registerAt(this.styles);

	row.setStyle(type.getStyleId());
	row.addAttribute({
		name: 'customFormat',
		value: '1'
	});

	this.columns.forEach(function(column, index, array) {

		/* Create new Cell and assign value */
		cell = new Cell(type);
		cell.setValue('label', column);

		row.addCell(cell);
	});

	return row;
};

ColumnConfiguration.prototype.getGroupHeader = function(sGroupName) {
	var cell, row, type;

	row = new Row();
	type = new Text({
		font: {
			name: 'Arial',
			size: 11,
			bold: true
		},
		fill: {
			color: 'F2F2F2'
		}
	});

	/* Register header style */
	type.registerAt(this.styles);

	row.setStyle(type.getStyleId());
	row.addAttribute({
		name: 'customFormat',
		value: '1'
	});

	row.spans.value = '1:' + this.size();

	/* Create new Cell and assign value */
	cell = new Cell(type);
	cell.setValue('name', {name: sGroupName});

	row.addCell(cell);

	return row;
};


/**
 * Returns the size of the ColumnConfiguration - respectively the
 * count of the configured columns.
 *
 * @returns {number} Count of configured columns
 */
ColumnConfiguration.prototype.size = function() {
	return this.columns.length;
};

module.exports = ColumnConfiguration;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var BigNumber	 	= __webpack_require__(11),
	BooleanType 	= __webpack_require__(14),
	CalendarDate 	= __webpack_require__(13),
	Cell			= __webpack_require__(3),
	Currency 		= __webpack_require__(4),
	Enumeration 	= __webpack_require__(28),
	Numeric 		= __webpack_require__(5),
	Text		 	= __webpack_require__(16);

/**
 * The Column class represents the field type of columns. It handles
 * styling, data types and data binding.
 *
 * @param {(Object|string)} oData - Data object representing the Column configuration
 * @param {string} oData.property - References the data object property that is bound as value for this column
 * @param {string} [oData.textAlign] - Optional alignment
 * @param {string} [oData.label] - Optional column label that will be shown in the header row
 * @param {string} [oData.type] - Optional data type for this column. Default: Column.Type.Text
 * @param {string} [oData.width] - Optional width of the
 * @param {Styles} oStyles - Styles collection that is needed to register each Style a Column uses
 * @class
 * @module binding/Column
 */
function Column(oData, oStyles) {
	var oColumnData;

	/* Fallback assignment if only a key is provided */
	oColumnData = typeof oData === 'string' ? {property: oData} : oData;
	if (!oColumnData || !oColumnData.property) { throw new Error('The property for the column is not defined'); }

	this.property = oColumnData.property;
	this.label = oColumnData.label ? oColumnData.label : oColumnData.property;
	this.width = oColumnData.width;
	this.styles = oStyles;
	this.type = this._initType(oColumnData);
}

/**
 * Initializes the data type for this Column. Type specific
 * formatting information will be evaluated and applied.
 *
 * @param {Object} oData - Configuration object for this Column that also contains type and formatting information
 * @param {string} oData.type - Specifies the data type
 * @param {string} [oData.textAlign] - Defines the horizontal alignment
 * @param {boolean} [oData.delimiter] - Specifies if a thousands delimiter is shown
 * @param {number} [oData.scale] - Specifies the the decimal scale
 * @param {string} [oData.calendar] - Specifies the calendar if type is date, datetime or time
 * @param {string} [oData.format] - Specifies a custom format if type is date, datetime or time
 * @param {string} [oData.unit] - Specifies the UoM if type is number
 * @param {string} [oData.unitProperty] - Name of the property that contains the UoM if type is number or currency
 * @param {boolean} [oData.displayUnit] - Specifies if the UoM will be shown or not if type is number or currency
 * @param {string} [oData.trueValue] - Specifies the displayed value if the boolean type has the value true
 * @param {string} [oData.falseValue] - Specifies the displayed value if the boolean type has the value false
 * @param {string} [oData.template] - Specifies a template string that can be filled with several properties
 * @param {string} [oData.hierarchyLevel] - Specifies the name of the property that contains the hierarchy level
 * @param {string} [oData.inputFormat] - Specifies the input format of a string based date
 * @param {Object} [oData.valueMap] - Contains a JS object or Map with key value pairs
 *
 * @returns {Type} - Returns the specific Type object that contains all the formatting
 * @private
 */
Column.prototype._initType = function(oData) {
	var type, sType;

	sType = oData.type;

	switch (sType) {
		case 'date':
		case 'datetime':
		case 'time':
			type = new CalendarDate(oData);

			/* Add "UTC" to all columns headers of type datetime to indicate that all timestamps in EXCEL are UTC */
			this.label = sType === 'datetime' ? this.label + ' (UTC)' : this.label;
			break;

		case 'number':
			type = new Numeric(oData);
			break;
		case 'currency':
			type = new Currency(oData);
			break;
		case 'boolean':
			type = new BooleanType(oData);
			break;
		case 'enumeration':
			type = new Enumeration(oData);
			break;
		case 'bignumber':
			type = new BigNumber(oData);
			break;
		default:
			oData.type = 'text';

			type = new Text(oData);
	}

	type.registerAt(this.styles);

	return type;
};

/**
 * Returns the Cell object that is referenced by this particular
 * Column. Every Column references only one single Cell that gets
 * reused for each and every Row.
 *
 * When binding the actual data to a row, the Cell content, its
 * references and its styling get updated and a serialized version
 * of the row is stored within the sheet.
 *
 * @returns {Cell} - The Cell that belongs to this particular Column
 */
Column.prototype.getCell = function() {
	if (!this.cell) {
		this.cell = new Cell(this.type);
	}

	return this.cell;
};

/**
 * This method binds the actual business object property to the columns cell.
 *
 * @param {object} oData - Business object that gets bound to the Cell of this Column.
 */
Column.prototype.bind = function(oData) {

	/*
	 * Due to the fact that Cell#setValue updates the Style depending
	 * on the actual Cell value (i.E. Unit of Measurement for
	 * Currencies), we need to provide the original business object
	 * so that the Cell knows the whole business object instead of
	 * just the value of its particular property.
	 */
	this.cell.setValue(this.property, oData);
};

module.exports = Column;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var Type = __webpack_require__(2);

/**
 * The Enumeration class represents an enumeration data type.
 * The Enumeration allows to assign particular values for
 * corresponding keys.
 *
 * @param {Object} [oConfig] - Configuration object for this numeric representation
 * @param {Object} [oData.valueMap] - Contains a JS object or Map with key value pairs
 * @constructor
 */
function Enumeration(oConfig) {
	Type.call(this, oConfig);

	this._valueMap = oConfig && oConfig.valueMap ? oConfig.valueMap : {};
}

Enumeration.prototype = Object.create(Type.prototype);
Enumeration.prototype.constructor = Enumeration;

/**
 * Returns the mapped value for the key that is present in the
 * business object.
 *
 * @param {string|Array} sProperty - Name of the property that contains the key
 * @param {Object} oData - Business object that contains the data
 * @returns {string} - The value of the given property after type specific processing
 * @protected
 */
Enumeration.prototype.getValue = function(sProperty, oData) {
	var key, result;

	key = oData[sProperty];
	result = this._valueMap instanceof Map ? this._valueMap.get(key) : this._valueMap[key];

	return result || '';
};

module.exports = Enumeration;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var XMLFile			= __webpack_require__(1),
	Relationships	= __webpack_require__(8);

/**
 * This class represents the a Office Open XML Spreadsheet object
 * that is related to other objects via Relationships. The object
 * manages its Relationships by itself to encapsulate the complexity.
 *
 * A ReferenceNode also provides information about its path so that
 * all relationships that are connected to this ReferenceNode are are
 * relative to its path.
 *
 * @param {Object} oConfig - Configuration object that is used by the super class XMLFile
 * @constructor
 */
function ReferenceNode(oConfig) {
	XMLFile.call(this, oConfig);

	this._relatedFiles = [];
	this._relationships = new Relationships(this);

	this.addRelatedFile(this._relationships);
}

ReferenceNode.prototype = Object.create(XMLFile.prototype);
ReferenceNode.prototype.constructor = ReferenceNode;


ReferenceNode.prototype.addRelatedFile = function(oXMLFile) {
	if (!(oXMLFile instanceof XMLFile)) {
		throw new Error('A related file must be of type XMLFile');
	}

	this._relatedFiles.push(oXMLFile);
};

ReferenceNode.prototype.getRelationships = function() {
	return this._relationships;
};

/**
 * Returns an Array of {@link XMLFile} objects that are reference by
 * this {@link ReferenceNode}. The method provides a flat copy of the
 * original data to avoid manipulation.
 *
 * @returns {Array} Array containing referenced files
 */
ReferenceNode.prototype.getRelatedFiles = function() {
	return this._relatedFiles.slice();
};

module.exports = ReferenceNode;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var XMLFile			= __webpack_require__(1),
	Style			= __webpack_require__(31),
	Font			= __webpack_require__(32),
	Fill			= __webpack_require__(33),
	Border			= __webpack_require__(34),
	NumberFormat	= __webpack_require__(35);

/**
 *
 * @class
 * @module style/Styles
 */
function Styles() {
	XMLFile.call(this, Styles.metadata);

	/* Microsoft Excel fix - specific fill that needs to be present */
	this.addFill({ type: 'none' }); // Add a default fill at index 0
	this.addFill({ type: 'gray125' }); // Needs to have index 1
	this.addStyle(Style.DEFAULT); // Apply base style to feed the hard-coded cellStyles and cellStyleXfs
}

Styles.prototype = Object.create(XMLFile.prototype);
Styles.prototype.constructor = Styles;

Styles.metadata = {
	filename: 'styles.xml',
	tag: 'styleSheet',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main'
		},
		{
			name: 'xmlns',
			suffix: 'mc',
			value: 'http://schemas.openxmlformats.org/markup-compatibility/2006'
		}
	],
	properties: [
		{
			id: 'numberFormats',
			tag: 'numFmts',
			attributes: [
				{
					id: 'count',
					name: 'count',
					value: '0'
				}
			]
		},
		{
			id: 'fonts',
			tag: 'fonts',
			attributes: [
				{
					id: 'count',
					name: 'count',
					value: '0'
				}
			]
		},
		{
			id: 'fills',
			tag: 'fills',
			attributes: [
				{
					id: 'count',
					name: 'count',
					value: '0'
				}
			]
		},
		{
			id: 'borders',
			tag: 'borders',
			attributes: [
				{
					id: 'count',
					name: 'count',
					value: '0'
				}
			]
		},
		{
			tag: 'cellStyleXfs',
			attributes: [
				{
					name: 'count',
					value: '1'
				}
			],
			properties: [
				{
					tag: 'xf',
					attributes: [
						{
							name: 'numFmtId',
							value: '0'
						},
						{
							name: 'fontId',
							value: '0'
						},
						{
							name: 'fillId',
							value: '0'
						},
						{
							name: 'borderId',
							value: '0'
						}
					]
				}
			]
		},
		{
			id: 'cellXfs',
			tag: 'cellXfs',
			attributes: [
				{
					id: 'count',
					name: 'count',
					value: '0'
				}
			]
		},
		{
			tag: 'cellStyles',
			attributes: [
				{
					name: 'count',
					value: '1'
				}
			],
			properties: [
				{
					tag: 'cellStyle',
					attributes: [
						{
							name: 'name',
							value: 'Normal'
						},
						{
							name: 'xfId',
							value: '0'
						},
						{
							name: 'builtinId',
							value: '0'
						}
					]
				}
			]
		},
		{
			tag: 'dxfs',
			attributes: [
				{
					name: 'count',
					value: '0'
				}
			]
		},
		{
			tag: 'tableStyles',
			attributes: [
				{
					name: 'count',
					value: '0'
				},
				{
					name: 'defaultTableStyle',
					value: 'TableStyleMedium2'
				},
				{
					name: 'defaultPivotStyle',
					value: 'PivotStyleLight16'
				}
			]
		}
	]
};


/**
 * Adds the specified Style to the Styles class according to the
 * Style configuration. The method will return a Style object that
 * references Font, Fill, Border and an optional NumberFormat. If
 * some of the referenced Font, Fill, Border or NumberFormat objects
 * are not present yet, it will create them automatically, otherwise
 * it will re-use existing ones.
 *
 * The method ensures that particular Style combinations exist only
 * once and there are no duplicates.
 *
 * @param {Object} oData - Configuration object that defines the Style information
 * @param {Object} [oData.font] - Configuration object that defines the Font information
 * @param {string} [oData.font.name] - Name of the used Font i.E. 'Arial'
 * @param {string} [oData.font.size] - Preferred Font size i.E. '12'
 * @param {boolean} [oData.font.bold] - Defines the Font weight
 * @param {Object} [oData.fill] - Configuration object that defines the Fill information
 * @param {string} [oData.fill.color] - HEX string defining the color of the cell fill
 * @param {string} [oData.fill.type] - Defines the type of the fill i.E. 'none' or 'solid'
 * @param {Object} [oData.border] - Configuration object that defines the Border information
 * @param {Object|number} [oData.numberFormat] - Configuration object that defines the NumberFormat information
 * @param {string} [oData.numberFormat.format] - Formatting template that will be used
 * @param {Object} [oData.align] - Defines the text alignment within the cell
 * @param {string} [oData.align.horizontal] - Horizontal alignment
 * @param {string} [oData.align.vertical] - Vertical alignment
 * @param {number} [oData.align.indent] - Cell indentation
 * @returns {number} - The ID of the unique Style object that needs to be referenced
 */
Styles.prototype.addStyle = function(oData) {
	var style, fontId, fillId, borderId, numberFormatId;

	/* Add Font, Fill, Border and NumberFormat if needed */
	fontId = this.addFont(oData.font);
	fillId = this.addFill(oData.fill);
	borderId = this.addBorder(oData.border);

	/* Fallback to avoid custom NumberFormats that won't be used if oData.numberFormat is undefined */
	if (typeof oData.numberFormat === 'undefined') {
		oData.numberFormat = 0;
	}

	numberFormatId =
		NumberFormat._isBuiltin(oData.numberFormat) ? oData.numberFormat : this.addNumberFormat(oData.numberFormat);

	/* Create temporary Style */
	style = new Style();

	style.setFontId(fontId);
	style.setFillId(fillId);
	style.getBorderId(borderId);
	style.setNumberFormatId(numberFormatId);
	style.setAlignment(oData.align);

	/* Add Style if not already present */
	return this._addToAggregation(style, this.cellXfs);
};


/**
 * Adds the specific item to the provided aggregation. This Method
 * should only be called by the library itself due to possible
 * failures. It automatically updates the count within the XML
 * representation of this aggregation.
 *
 * This method should only be used for Font, Fill, Border or
 * NumberFormat objects.
 *
 * @param {Font|Fill|Border|NumberFormat|Style} oNewItem - The item that needs to be appended to the aggregation
 * @param {Array} aAggregation - An array that represents the aggregation
 * @returns {number} - The zero-based index of the element after it was inserted
 * @private
 */
Styles.prototype._addToAggregation = function(oNewItem, aAggregation) {
	var count, i;

	i = -1;

	aAggregation.childs.forEach(function(existingItem, index, array) {
		if (existingItem.equals(oNewItem)) {
			i = index;
		}
	});

	if (i === -1) {
		aAggregation.addChild(oNewItem);
		count = aAggregation.childs.length;

		aAggregation.count.value = count;
		i = count - 1;
	}

	return i;
};


/**
 * This method adds a RGB color to the Styles collection that is
 * referenced by several Styles.
 *
 * If this particular color is already present, it will not add it a
 * second time.
 *
 * @param {string} sHexColor - HEX string representing a RGB color
 */
Styles.prototype.addColor = function(sHexColor) {
	var alreadyPresent;

	if (!this.colors) {
		this.addChild({
			id: 'colors',
			tag: 'colors',
			properties: [
				{
					id: 'mru',
					tag: 'mruColors'
				}
			]
		});
	}

	alreadyPresent = this.colors.mru.childs.some(function(color) {
		return color.rgb.value === 'FF' + sHexColor;
	});

	if (alreadyPresent) {
		return;
	}

	this.colors.mru.addChild({
		tag: 'color',
		attributes: [
			{
				id: 'rgb',
				name: 'rgb',
				value: 'FF' + sHexColor
			}
		]
	});
};


/**
 * This method adds a Font to the Styles collection that can be
 * referenced by several Styles. The Font is instantiated according
 * to the provided configuration object.
 *
 * If this particular Font is already present, it will not add it a
 * second time. This ensures that each referenced Font is unique
 * according to the criteria of Font#equals.
 *
 * The method returns the index which deals as an identifier for this
 * Font.
 *
 * @param {Object} oData - Configuration object for this Font
 * @returns {number} - The index of this Font used for reference by Style objects
 */
Styles.prototype.addFont = function(oData) {
	var oFont = new Font(oData);

	return this._addToAggregation(oFont, this.fonts);
};


/**
 * This method adds a Fill to the Styles collection that can be
 * referenced by several Styles. The Fill is instantiated according
 * to the provided configuration object.
 *
 * If this particular Fill is already present, it will not add it a
 * second time. This ensures that each referenced Fill is unique
 * according to the criteria of Fill#equals.
 *
 * The method returns the index which deals as an identifier for this
 * Fill.
 *
 * @param {Object} oData - Configuration object for this Fill
 * @returns {number} - The index of this Fill used for reference by Style objects
 */
Styles.prototype.addFill = function(oData) {
	var index, oFill;

	oFill = new Fill(oData);

	index = this._addToAggregation(oFill, this.fills);

	if (oFill.getFill() !== null) {
		this.addColor(oFill.getFill());
	}

	return index;
};


/**
 * This method adds a Border to the Styles collection that can be
 * referenced by several Styles. The Border is instantiated according
 * to the provided configuration object.
 *
 * If this particular Border is already present, it will not add it a
 * second time. This ensures that each referenced Border is unique
 * according to the criteria of Border#equals.
 *
 * The method returns the index which deals as an identifier for this
 * Border.
 *
 * @param {Object} oData - Configuration object for this Border
 * @returns {number} - The index of this Border used for reference by Style objects
 */
Styles.prototype.addBorder = function(oData) {
	var oBorder = new Border(oData);

	return this._addToAggregation(oBorder, this.borders);
};


/**
 * This method adds a NumberFormat to the Styles collection that can
 * be referenced by several Styles. The NumberFormat is instantiated
 * according to the provided configuration object.
 *
 * If this particular NumberFormat is already present, it will not
 * add it a second time. This ensures that each referenced
 * NumberFormat is unique according to the criteria of
 * NumberFormat#equals.
 *
 * The method returns the index which deals as an identifier for this
 * NumberFormat.
 *
 * @param {Object} oData - Configuration object for this NumberFormat
 * @returns {number} - The index of this NumberFormat used for reference by Style objects
 */
Styles.prototype.addNumberFormat = function(oData) {
	var index, numberFormat;

	numberFormat = new NumberFormat(oData);
	index = this._addToAggregation(numberFormat, this.numberFormats);

	numberFormat.setId(NumberFormat.ID_OFFSET + index);

	return numberFormat.getId();
};

module.exports = Styles;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var XMLNode = __webpack_require__(0);
var Alignment = __webpack_require__(6);

/**
 * Represents a particular Style within the Office Open XML Spreadsheet.
 * Instances of this type will be created by the Styles Class after
 * registering a new Style.
 *
 * @constructor
 */
function Style() {
	XMLNode.call(this, Style.metadata);
}

Style.prototype = Object.create(XMLNode.prototype);
Style.prototype.constructor = Style;

Style.metadata = {
	tag: 'xf',
	attributes: [
		{
			id: 'numberFormat',
			name: 'numFmtId',
			value: '0'
		},
		{
			id: 'font',
			name: 'fontId',
			value: '0'
		},
		{
			id: 'fill',
			name: 'fillId',
			value: '0'
		},
		{
			id: 'border',
			name: 'borderId',
			value: '0'
		}
	]
};

Style.DEFAULT = {
	font: {
		name: 'Arial',
		size: 11,
		family: '2',
		color: '1',
		bold: false
	},
	fill: {
		type: 'none'
	}
};

Style.prototype.getAlignment = function() {
	return this.alignment ? this.alignment : null;
};

Style.prototype.getFontId = function() {
	return this.font.value;
};

Style.prototype.getFillId = function() {
	return this.fill.value;
};

Style.prototype.getBorderId = function() {
	return this.border.value;
};

Style.prototype.getNumberFormatId = function() {
	return this.numberFormat.value;
};

/**
 * Applies the alignment to the Style. The alignment must match the
 * predefined options of <code>Alignment</code> as far as it is not
 * null. Other values will be ignored.
 *
 * The value <code>null</code> will delete the current alignment.
 *
 * @param {Object} oAlign - Alignment configuration that gets applied or null
 * @param {string} [oAlign.horizontal] - Horizontal alignment
 * @param {string} [oAlign.vertical] - Vertical alignment
 * @param {number} [oAlign.indent] - Cell indentation
 */
Style.prototype.setAlignment = function(oAlign) {
	var alignment, alignProperty;

	alignProperty = 'alignment';

	// Removes the applyAlignment automatically when sAlign is null
	this._apply(oAlign, 'Alignment');

	if (typeof oAlign === 'undefined' || oAlign === null) {
		this.remove(alignProperty);

		return;
	}

	if (!(alignProperty in this)) {
		alignment = new Alignment();

		this.addChild(alignment);
		Object.defineProperty(this, alignProperty, {value: alignment, writable: false, configurable: true});
	}

	this[alignProperty].setHorizontalAlignment(oAlign.horizontal);
	this[alignProperty].setVerticalAlignment(oAlign.vertical);
	this[alignProperty].setWrapText(oAlign.wrap);
	this[alignProperty].setIndent(oAlign.indent);
};

Style.prototype.setFontId = function(nFontId) {
	this._apply(nFontId, 'Font');

	this.font.value = nFontId;
};

Style.prototype.setFillId = function(nFillId) {
	this._apply(nFillId, 'Fill');

	this.fill.value = nFillId;
};

Style.prototype.setBorderId = function(sBorderId) {
	this.border.value = sBorderId;
};

Style.prototype.setNumberFormatId = function(nNumFmtId) {
	this._apply(nNumFmtId, 'NumberFormat');

	this.numberFormat.value = nNumFmtId;
};

Style.prototype._apply = function(nId, sType) {
	var applyProperty = 'apply' + sType;

	this.remove(applyProperty);

	if (nId) {
		this.addAttribute({
			id: applyProperty,
			name: applyProperty,
			value: '1'
		});
	}
};

Style.prototype.equals = function(oStyle) {
	if (!(oStyle instanceof Style)) {
		return false;
	}

	return this.getFontId() === oStyle.getFontId()
		&& this.getFillId() === oStyle.getFillId()
		&& this.getBorderId() === oStyle.getBorderId()
		&& this.getNumberFormatId() === oStyle.getNumberFormatId()
		&& ( (!this.alignment && !oStyle.alignment) || (this.alignment && this.alignment.equals(oStyle.alignment)) );
};

module.exports = Style;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var XMLNode = __webpack_require__(0);

/**
 * The Font class represents a Font configuration within an Office
 * Open XML Spreadsheet.
 *
 * @param {Object} oData - Configuration object for this Font
 * @param {boolean} [oData.bold] - Boolean value indicating if the Font should be bold
 * @param {string} [oData.name] - The name of the font that gets used by this Font object i.E. Arial, Verdana, etc.
 * @param {number|String} [oData.size] - The font size that is been used
 * @param {number} [oData.family] - The font family reference {@see getFamily}
 * @constructor
 */
function Font(oData) {
	XMLNode.call(this, Font.metadata);

	if (oData && oData instanceof Object) {
		this.setName(oData.name)
			.setSize(oData.size)
			.setFamily(oData.family)
			.setBold(!!oData.bold);
	}
}

Font.prototype = Object.create(XMLNode.prototype);
Font.prototype.constructor = Font;

Font.DEFAULT_SIZE = 11;
Font.DEFAULT_NAME = 'Arial';

Font.metadata = {
	tag: 'font',
	properties: [
		{
			id: 'size',
			tag: 'sz',
			attributes: [
				{
					id: 'valueAttribute',
					name: 'val',
					value: Font.DEFAULT_SIZE
				}
			]
		},
		{
			id: 'color',
			tag: 'color',
			attributes: [
				{
					id: 'valueAttribute',
					name: 'theme',
					value: '1'
				}
			]
		},
		{
			id: 'name',
			tag: 'name',
			attributes: [
				{
					id: 'valueAttribute',
					name: 'val',
					value: Font.DEFAULT_NAME
				}
			]
		},
		{
			id: 'family',
			tag: 'family',
			attributes: [
				{
					id: 'valueAttribute',
					name: 'val',
					value: 2
				}
			]
		}
	]
};

/**
 * Checks if the current Font is equal to the given parameter.
 *
 * @param {Font} oFont - The Font to compare with
 * @return {boolean} - Returns true if both Font objects contain the same configuration.
 */
Font.prototype.equals = function(oFont) {
	if (!(oFont instanceof Font)) {
		return false;
	}

	return this.getName() == oFont.getName()
		&& this.getSize() == oFont.getSize()
		&& this.isBold() == oFont.isBold()
		&& this.getColor() == oFont.getColor()
		&& this.getFamily() == oFont.getFamily();
};

/**
 * Returns whether the Font will be displayed bold or not.
 *
 * @returns {boolean} - Returns true if the Font is bold
 */
Font.prototype.isBold = function() {
	return !!this.bold;
};

/**
 * Returns the size of this Font.
 *
 * @returns {number} - The size of the Font
 */
Font.prototype.getSize = function() {
	return this.size.valueAttribute.value;
};

/**
 * Returns the name of this Font. I.E. Arial, Calibri, etc.
 *
 * @returns {string} - The name of the Font
 */
Font.prototype.getName = function() {
	return this.name.valueAttribute.value;
};

/**
 * Returns the color reference of this Font.
 *
 * @returns {string} - The color as HEX string
 */
Font.prototype.getColor = function() {
	return this.color.valueAttribute.value;
};

/**
 * Returns the Font family reference of this Font. The reference is
 * defined within the Office Open XML specification.
 * 1 : Roman (Times New Roman, SAP-icons)
 * 2 : Swiss (Arial, Calibri, Segoe UI, Tahoma, Verdana)
 * 3 : Modern
 * 4 : Script
 * 5 : Decorative
 * 6-14 : Reserved for future use
 *
 * @returns {number} - The Font family ID
 */
Font.prototype.getFamily = function() {
	return this.family.valueAttribute.value;
};

/**
 * This method can be used to set the Font to bold or not.
 *
 * @param {boolean} bBold - A boolean value that indicates if the Font should be bold or not
 * @return {Font} - Returns the current Font object for chaining
 */
Font.prototype.setBold = function(bBold) {
	var boldProperty = 'bold';

	/* Early return if bold status is already correct */
	if (bBold === !!this[boldProperty]) {
		return this;
	}

	if (bBold) {
		this.addChild({
			id: boldProperty,
			tag: 'b'
		});
	} else {
		this.remove(boldProperty);
	}

	return this;
};

/**
 * This method is used to set the Font family reference for the used font.
 *
 * @see {@link getFamily}
 * @param {number} nFamily - Number that references the Font family
 * @returns {Font} - Returns the current Font object for chaining
 */
Font.prototype.setFamily = function(nFamily) {

	if (nFamily > 0 && nFamily < 15) {
		this.family.valueAttribute.value = nFamily;
	}

	return this;
};

/**
 * Assigns the given font name to this object.
 *
 * @param {string} sName - Name of the font i.E. Arial, Calibri, etc.
 * @return {Font} - Returns the current Font object for chaining
 */
Font.prototype.setName = function(sName) {
	if (sName && typeof sName === 'string') {
		this.name.valueAttribute.value = sName;
	}

	/*
	 * If the font name is Calibri we need to add another child node:
	 *
	 *	{
	 *		tag: 'scheme',
	 *		attributes: [
	 *			{
	 *				name: 'val',
	 *				value: 'minor'
	 *			}
	 *		]
	 *	}
	 */

	return this;
};

/**
 * Assigns the given font size to this object.
 *
 * @param {number} nSize - Textual representation of the font size
 * @return {Font} - Returns the current Font object for chaining
 */
Font.prototype.setSize = function(nSize) {

	/* Check preconditions */
	if (typeof nSize !== 'number' || isNaN(nSize) || nSize < 1 || nSize > 96) {
		throw new Error('The size ' + nSize + ' is not supported.');
	}

	this.size.valueAttribute.value = nSize;

	return this;
};

module.exports = Font;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var XMLNode = __webpack_require__(0);

/**
 * This Class represents a background fill of cells within the Office
 * Open Spreadsheet document. The Fill accepts a configuration object
 * which might have either an "color" or an "type" property.
 *
 * @param {Object} oData - Configuration object for this Fill
 * @param {string} [oData.color] - HEX string defining the colored fill
 * @param {string} [oData.type] - Color independent fill type
 * @constructor
 */
function Fill(oData) {
	XMLNode.call(this, Fill.metadata);

	if (oData) {
		if (oData.color) {
			this.setFill(oData.color);
		} else if (oData.type) {
			this.setType(oData.type);
		}
	}
}

Fill.prototype = Object.create(XMLNode.prototype);
Fill.prototype.constructor = Fill;

Fill.DEFAULT_TYPE = 'none';

Fill.metadata = {
	tag: 'fill',
	properties: [
		{
			id: 'fill',
			tag: 'patternFill',
			attributes: [
				{
					id: 'type',
					name: 'patternType',
					value: Fill.DEFAULT_TYPE
				}
			]
		}
	]
};

/**
 * Checks if the current Fill is equal to the one that was provided.
 *
 * @param {Fill} oFill - The Fill that gets compared to the current Fill
 * @returns {boolean} - Returns true if the compared objects are of the same type and contain the same color fill
 */
Fill.prototype.equals = function(oFill) {
	if (!(oFill instanceof Fill)) {
		return false;
	}

	return this.getType() === oFill.getType()
		&& this.getFill() === oFill.getFill();
};

/**
 * Returns the color of the current Fill.
 *
 * @returns {string|null} - String containing the color HEX color of the Fill or null of no color is assigned
 */
Fill.prototype.getFill = function() {

	/* The opacity needs to be removed before returning the HEX color */
	return this.fill.childs.length ? this.fill.color.rgb.value.substring(2) : null;
};

Fill.prototype.setFill = function(sColor) {
	this.reset();

	if (sColor && typeof sColor === 'string' && /^[A-Fa-f0-9]{6}$/.test(sColor)) {
		this.fill.type.value = 'solid';

		/**
		 * Apply the provided color as forground color of the
		 * background. We add 'FF' in front of the HEX-color
		 * for opacity.
		 */
		this.fill.addChild({
			id: 'color',
			tag: 'fgColor',
			attributes: [
				{
					id: 'rgb',
					name: 'rgb',
					value: 'FF' + sColor
				}
			]
		});

		/**
		 * Add default background layer which will be used once the
		 * foreground color uses transparency
		 */
		this.fill.addChild({
			tag: 'bgColor',
			attributes: [
				{
					name: 'indexed',
					value: '64'
				}
			]
		});
	}
};

/**
 * Returns the current Fill type.
 *
 * @returns {string} - Current Fill type
 */
Fill.prototype.getType = function() {
	return this.fill.type.value;
};

/**
 * Assigns the given type as Fill type. The Fill will be reset to
 * default before the type is applied.
 *
 * @param {string} sType - Type that needs to be assigned
 */
Fill.prototype.setType = function(sType) {
	this.reset();

	this.fill.type.value = sType;
};

/**
 * Resets the current fill to avoid side effects that might occur
 * when the fill is modified.
 */
Fill.prototype.reset = function() {
	this.fill.type.value = 'none';
	this.fill.childs.length = 0;
};

module.exports = Fill;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var XMLNode = __webpack_require__(0);

/**
 * This class represents border configuration for Office Open XML Spreadsheets.
 * @constructor
 */
function Border() {
	XMLNode.call(this, Border.metadata);
}

Border.prototype = Object.create(XMLNode.prototype);
Border.prototype.constructor = Border;

Border.metadata = {
	tag: 'border',
	properties: [
		{
			tag: 'left'
		},
		{
			tag: 'right'
		},
		{
			tag: 'top'
		},
		{
			tag: 'bottom'
		},
		{
			tag: 'diagonal'
		}
	]
};

/**
 * Checks if the current Border is equal to the given parameter.
 *
 * @param {Border} oBorder - Border that get's compared to the current one
 * @return {boolean} - Returns true if both Borders have the same configuration
 */
Border.prototype.equals = function(oBorder) {

	/**
	 * Once it is a Border object we always return true because we
	 * don't provide more than one border type
	 */
	return oBorder instanceof Border;
};

module.exports = Border;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var XMLNode = __webpack_require__(0);

/**
 * The NumberFormat class is used to store custom formatting for
 * numeric values. In addition to a variety of built-in formats that
 * cannot be used as identifier for a particular format, the user can
 * create up to 250 different number formats.
 *
 * (https://support.office.com/en-us/article/Excel-specifications-and-limits-1672b34d-7043-467e-8e27-269d656771c3)
 *
 * @param {Object} oData - Configuration object that is used for initialization
 * @param {string} oData.format - Custom format that will be applied
 * @constructor
 */
function NumberFormat(oData) {
	XMLNode.call(this, NumberFormat.metadata);

	this.format.value = oData && oData.format ? oData.format : NumberFormat.DEFAULT;
}

NumberFormat.prototype = Object.create(XMLNode.prototype);
NumberFormat.prototype.constructor = NumberFormat;

NumberFormat.metadata = {
	tag: 'numFmt',
	attributes: [
		{
			id: 'formatId',
			name: 'numFmtId'
		},
		{
			id: 'format',
			name: 'formatCode'
		}
	]
};

NumberFormat.BUILTIN_IDS = [ 0, 1, 2, 3, 4, 9, 10, 11, 12, 13, 14, 15,
	16, 17, 18, 19, 20, 21, 22, 37, 38, 39, 40, 45, 46, 47, 48, 49 ];
NumberFormat.ID_OFFSET = 166;
NumberFormat.DEFAULT = '#,##0.00';

/**
 * This method returns the ID of this NumberFormat. If there was no
 * ID assigned yet, it will return undefined.
 *
 * @returns {number} - The ID of this NumberFormat
 */
NumberFormat.prototype.getId = function() {
	return this.formatId.value;
};


/**
 * Returns the format of this NumberFormat as a string.
 *
 * @returns {string} - The format template that gets applied
 */
NumberFormat.prototype.getFormat = function() {
	return this.format.value;
};


/**
 * Assigns the provided ID to the current NumberFormat.
 *
 * @param {number|string} sId - The ID of this NumberFormat that can be referenced
 */
NumberFormat.prototype.setId = function(sId) {
	var iId = typeof sId === 'number' ? sId : parseInt(sId, 10);

	/* Checks if NaN, below zero or builtin ID */
	if (isNaN(iId) || iId < 0 || NumberFormat._isBuiltin(iId)) {
		return;
	}

	this.formatId.value = sId;
};


/**
 * Sets a specific format.
 *
 * @param {string} sFormat - The format that gets applied by this NumberFormat
 */
NumberFormat.prototype.setFormat = function(sFormat) {
	this.format.value = sFormat;
};


/**
 * Checks if a given ID is a builtin ID or not. Builtin IDs cannot be used for custom NumberFormats.
 *
 * @param {number} iId - ID that needs to be checked if it is a builtin ID
 *
 * @returns {boolean} - Returns true if the provided ID is a builtin ID that cannot be used
 * @private
 */
NumberFormat._isBuiltin = function(iId) {
	return NumberFormat.BUILTIN_IDS.indexOf(iId) > -1;
};


/**
 * Compares another NumberFormat to the current one. This method will
 * match NumberFormat objects by its format regardless of their ID.
 *
 * @param {NumberFormat} oNumberFormat - The NumberFormat to compare with
 * @returns {boolean} - Returns true if the format template is equal to the one from the compared object
 */
NumberFormat.prototype.equals = function(oNumberFormat) {
	if (!(oNumberFormat instanceof NumberFormat)) {
		return false;
	}

	return this.getFormat() === oNumberFormat.getFormat();
};

module.exports = NumberFormat;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// XLSXBuilder.js